/** Auto-generated by scripts/refresh-collection-catalog.mjs — do not edit. */
export const ICP_COLLECTION_CATALOG = {
    "updatedAt": "2026-09-23T21:40:10.568Z",
    "count": 1341,
    "namedCount": 884,
    "sources": [
        "yumi-seed",
        "bazaar-seed",
        "extra-seed",
        "existing-catalog",
        "entrepot-api",
        "dgdg-collections",
        "nftgeek-api",
        "dab-github",
        "dab-nft-registry",
        "bazaar-registry",
        "bioniq-api"
    ],
    "canisters": [
        "22i66-dyaaa-aaaah-adwwq-cai",
        "24ark-haaaa-aaaam-qazoa-cai",
        "24irw-5aaaa-aaaaj-qalhq-cai",
        "26acc-dqaaa-aaaag-qbhsa-cai",
        "26snc-oqaaa-aaaai-qoxta-cai",
        "27qc3-lyaaa-aaaap-aaimq-cai",
        "27x62-syaaa-aaaag-qbmda-cai",
        "2amlh-kaaaa-aaaaj-qalfq-cai",
        "2ceyt-uqaaa-aaaag-qbhqa-cai",
        "2dcmy-kyaaa-aaaag-qc4lq-cai",
        "2dtsz-iyaaa-aaaam-qa6ra-cai",
        "2duyk-4yaaa-aaaap-aaioq-cai",
        "2dwmv-lyaaa-aaaag-qdgla-cai",
        "2ftkf-7iaaa-aaaag-qbyva-cai",
        "2gghi-aqaaa-aaaag-qa2na-cai",
        "2glp2-eqaaa-aaaak-aajoa-cai",
        "2h3ov-yqaaa-aaaae-qaeva-cai",
        "2iiif-4qaaa-aaaah-qcs5a-cai",
        "2j7u5-nyaaa-aaaah-qczma-cai",
        "2jzuz-2iaaa-aaaaj-qaubq-cai",
        "2kon3-cqaaa-aaaaj-qat4q-cai",
        "2l7rh-eiaaa-aaaah-qcvaa-cai",
        "2mgdj-caaaa-aaaam-qavba-cai",
        "2mgv3-paaaa-aaaag-qbhra-cai",
        "2n77z-oyaaa-aaaao-aakuq-cai",
        "2nelu-kqaaa-aaaag-qkaia-cai",
        "2oggt-lqaaa-aaaam-qazna-cai",
        "2oyfj-oyaaa-aaaae-qaeuq-cai",
        "2rarf-5qaaa-aaaag-qkaka-cai",
        "2remf-7aaaa-aaaal-qcm5a-cai",
        "2rvts-jiaaa-aaaag-qbmca-cai",
        "2s2iy-xaaaa-aaaah-qczoq-cai",
        "2tvxo-eqaaa-aaaai-acjla-cai",
        "2v5zm-uaaaa-aaaae-qaewa-cai",
        "2vd2w-riaaa-aaaam-qazpq-cai",
        "2vl2k-liaaa-aaaaj-qalga-cai",
        "2wf5f-3qaaa-aaaap-aaxiq-cai",
        "2wucc-5yaaa-aaaal-qb4xa-cai",
        "2x3lw-tiaaa-aaaah-qcvca-cai",
        "2xgcb-7aaaa-aaaah-aq4aa-cai",
        "2xv54-tyaaa-aaaag-qbywa-cai",
        "2zepj-eqaaa-aaaah-aq4ba-cai",
        "2zjt6-5aaaa-aaaah-adooa-cai",
        "2zw3f-pqaaa-aaaaf-qakaa-cai",
        "2zxqu-iiaaa-aaaag-qbyxa-cai",
        "323zs-4qaaa-aaaag-qbyrq-cai",
        "334ho-biaaa-aaaal-aayya-cai",
        "335nj-syaaa-aaaap-aaikq-cai",
        "33ete-2yaaa-aaaaj-qatza-cai",
        "33mfk-nyaaa-aaaag-qbtaq-cai",
        "343x4-gaaaa-aaaag-qbmfq-cai",
        "34fvq-xaaaa-aaaaj-qatzq-cai",
        "34k7p-jaaaa-aaaag-qc4pa-cai",
        "355dh-iiaaa-aaaap-aa46q-cai",
        "3a737-4aaaa-aaaam-qa6xq-cai",
        "3bag5-taaaa-aaaah-adoka-cai",
        "3bpne-jiaaa-aaaag-qcizq-cai",
        "3bqt5-gyaaa-aaaah-qcvha-cai",
        "3cjkh-tqaaa-aaaam-qan6a-cai",
        "3db6u-aiaaa-aaaah-qbjbq-cai",
        "3dic5-eyaaa-aaaam-qazkq-cai",
        "3dqwh-piaaa-aaaah-qczla-cai",
        "3e7gz-caaaa-aaaag-qbu7q-cai",
        "3ejej-jaaaa-aaaam-qazka-cai",
        "3exqx-vaaaa-aaaaj-qauga-cai",
        "3grvj-laaaa-aaaah-qcvhq-cai",
        "3h2b5-haaaa-aaaag-qjqfq-cai",
        "3h6lz-4yaaa-aaaag-qbmha-cai",
        "3hpdk-tyaaa-aaaag-qc4nq-cai",
        "3hzxy-fyaaa-aaaap-aaiiq-cai",
        "3ifmd-wqaaa-aaaah-qckda-cai",
        "3ilm3-3aaaa-aaaam-qavha-cai",
        "3j4qd-kiaaa-aaaam-qa6wa-cai",
        "3kt53-zaaaa-aaaah-qczkq-cai",
        "3l372-hyaaa-aaaag-qcpfa-cai",
        "3mttv-dqaaa-aaaah-qcn6q-cai",
        "3n4nf-uiaaa-aaaag-qbu6a-cai",
        "3nu3l-diaaa-aaaaj-qauhq-cai",
        "3o5af-kqaaa-aaaag-qbmgq-cai",
        "3odcj-3qaaa-aaaaj-qat2q-cai",
        "3omiw-fqaaa-aaaag-qc4ma-cai",
        "3rav4-fyaaa-aaaah-qcgnq-cai",
        "3rgvy-siaaa-aaaaj-qalaa-cai",
        "3rove-iiaaa-aaaam-qazjq-cai",
        "3toq6-byaaa-aaaam-qavfq-cai",
        "3tyso-kyaaa-aaaag-qbyqa-cai",
        "3ul5y-dqaaa-aaaal-qjlca-cai",
        "3vdxu-laaaa-aaaah-abqxa-cai",
        "3vjut-7iaaa-aaaag-qc4oq-cai",
        "3voic-wiaaa-aaaag-qbtbq-cai",
        "3vy4a-qiaaa-aaaag-qbmea-cai",
        "3whtm-7qaaa-aaaaj-qalaq-cai",
        "3yd6a-tqaaa-aaaah-qcgma-cai",
        "42fn2-wyaaa-aaaak-aafwq-cai",
        "437zq-dqaaa-aaaag-qa5eq-cai",
        "43sol-iqaaa-aaaak-qitiq-cai",
        "46sy3-aiaaa-aaaah-qczza-cai",
        "4bh3m-yaaaa-aaaaj-qatlq-cai",
        "4bpnc-paaaa-aaaag-qbtsa-cai",
        "4bzps-eaaaa-aaaam-qa6hq-cai",
        "4dz42-aqaaa-aaaag-qba3q-cai",
        "4fcza-biaaa-aaaah-abi4q-cai",
        "4fxe6-2qaaa-aaaah-qcz3q-cai",
        "4fzsu-2aaaa-aaaag-qbupq-cai",
        "4gbxl-byaaa-aaaak-aafuq-cai",
        "4ggk4-mqaaa-aaaae-qad6q-cai",
        "4gyjg-jyaaa-aaaam-qa6ha-cai",
        "4hzxo-tqaaa-aaaag-qbydq-cai",
        "4ibzi-eaaaa-aaaah-abqfa-cai",
        "4j32g-iaaaa-aaaag-qbycq-cai",
        "4k2xg-wyaaa-aaaag-qba2a-cai",
        "4k65c-naaaa-aaaag-qj4yq-cai",
        "4kubm-wiaaa-aaaah-qcnoa-cai",
        "4lnl6-hqaaa-aaaag-qblla-cai",
        "4m2zi-miaaa-aaaag-qbuoa-cai",
        "4mm3y-hiaaa-aaaam-qaz3q-cai",
        "4msyc-caaaa-aaaae-qaeca-cai",
        "4mupc-myaaa-aaaah-qcz2a-cai",
        "4nvhy-3qaaa-aaaah-qcnoq-cai",
        "4odun-ayaaa-aaaak-aarbq-cai",
        "4ojdp-jaaaa-aaaah-aq4ua-cai",
        "4p76m-jiaaa-aaaag-qjqua-cai",
        "4pa74-jyaaa-aaaah-abqfq-cai",
        "4pnak-uqaaa-aaaag-qbtta-cai",
        "4q4as-faaaa-aaaal-qab4q-cai",
        "4q6dz-3iaaa-aaaag-qbuma-cai",
        "4qmvs-qyaaa-aaaal-ab2rq-cai",
        "4roda-taaaa-aaaap-aa3sq-cai",
        "4s6gd-syaaa-aaaag-qbyaa-cai",
        "4smyf-paaaa-aaaag-qj3ha-cai",
        "4tb3r-nyaaa-aaaae-qad5a-cai",
        "4tj23-dqaaa-aaaag-qbtra-cai",
        "4uzum-riaaa-aaaap-aai3q-cai",
        "4vn6r-cyaaa-aaaag-qj3hq-cai",
        "4vy4g-waaaa-aaaag-qcxpq-cai",
        "4wiph-kyaaa-aaaam-qannq-cai",
        "4wuoq-vqaaa-aaaah-acmbq-cai",
        "4z5if-naaaa-aaaag-qbunq-cai",
        "4zv6l-2aaaa-aaaaj-qauua-cai",
        "527xj-ziaaa-aaaah-qcz7a-cai",
        "52b2m-tyaaa-aaaai-qpbpa-cai",
        "52hdt-syaaa-aaaam-qaz6q-cai",
        "52jdl-7iaaa-aaaah-qcg2q-cai",
        "53lcn-vyaaa-aaaah-ab4mq-cai",
        "54vfj-yqaaa-aaaag-qj45q-cai",
        "556r5-uqaaa-aaaah-qcz7q-cai",
        "55qhx-uaaaa-aaaag-qbulq-cai",
        "56pj5-7qaaa-aaaah-ad2ka-cai",
        "5bc7w-iaaaa-aaaam-qaz4a-cai",
        "5btbh-2aaaa-aaaap-aaqga-cai",
        "5clsk-myaaa-aaaaj-qatna-cai",
        "5gdzc-fyaaa-aaaam-qaz4q-cai",
        "5gv3s-oyaaa-aaaag-qbuja-cai",
        "5h2fc-zaaaa-aaaah-qcnjq-cai",
        "5i7j7-qiaaa-aaaak-qlqoa-cai",
        "5izaq-vyaaa-aaaah-qcz4a-cai",
        "5jw6a-caaaa-aaaag-qba4q-cai",
        "5kuny-yiaaa-aaaal-acgta-cai",
        "5kxta-4yaaa-aaaag-qbyea-cai",
        "5lapy-nqaaa-aaaag-qbtva-cai",
        "5lnqo-qyaaa-aaaah-abqdq-cai",
        "5lwni-gqaaa-aaaam-qa6aq-cai",
        "5movr-diaaa-aaaak-aaftq-cai",
        "5nrjf-yaaaa-aaaag-qcxlq-cai",
        "5otsq-uaaaa-aaaag-qj46q-cai",
        "5paem-6qaaa-aaaag-qblna-cai",
        "5pas6-tqaaa-aaaam-qaz5a-cai",
        "5pego-3aaaa-aaaar-axudq-cai",
        "5pyge-yaaaa-aaaah-qcz4q-cai",
        "5qtrn-4iaaa-aaaam-qa6ca-cai",
        "5rspf-gaaaa-aaaag-qbygq-cai",
        "5stux-vyaaa-aaaam-qasoa-cai",
        "5t24r-yqaaa-aaaaj-qauta-cai",
        "5t44v-paaaa-aaaah-qcz6q-cai",
        "5wr56-myaaa-aaaag-qa5da-cai",
        "5wtjr-lyaaa-aaaag-qbyga-cai",
        "5zoop-waaaa-aaaaj-qatpq-cai",
        "63ngu-eyaaa-aaaah-adfea-cai",
        "63w2e-gyaaa-aaaal-qdjcq-cai",
        "64sdk-4iaaa-aaaag-qbt5q-cai",
        "64x4q-laaaa-aaaal-qdjca-cai",
        "65f7s-naaaa-aaaag-qbymq-cai",
        "65hl5-kaaaa-aaaag-qa5jq-cai",
        "66orv-hqaaa-aaaah-acmnq-cai",
        "66sru-mqaaa-aaaal-qbpea-cai",
        "6arfk-ciaaa-aaaag-qc4qq-cai",
        "6bbfd-2aaaa-aaaag-qbyoq-cai",
        "6bt3f-hyaaa-aaaag-qj3jq-cai",
        "6bxrb-4aaaa-aaaag-qbhla-cai",
        "6c5sv-yyaaa-aaaah-aecoq-cai",
        "6dg4i-2qaaa-aaaag-qc3nq-cai",
        "6dm7p-oyaaa-aaaah-abxua-cai",
        "6e6eb-piaaa-aaaaj-qal6a-cai",
        "6eagn-6iaaa-aaaag-qbuca-cai",
        "6eaq7-tiaaa-aaaam-qagsa-cai",
        "6eh24-xiaaa-aaaag-qc3na-cai",
        "6enz3-daaaa-aaaah-abxuq-cai",
        "6f7n5-4iaaa-aaaah-adwpq-cai",
        "6fosk-kaaaa-aaaak-aawqq-cai",
        "6gcxy-qyaaa-aaaag-qa5la-cai",
        "6hgw2-nyaaa-aaaai-abkqq-cai",
        "6hgxm-zqaaa-aaaap-aaiva-cai",
        "6imyv-myaaa-aaaah-qcv3a-cai",
        "6iqqz-rqaaa-aaaag-qj3ia-cai",
        "6iu25-kiaaa-aaaag-qbhkq-cai",
        "6je2e-caaaa-aaaap-aaiua-cai",
        "6jvsh-5aaaa-aaaag-qbt6a-cai",
        "6jynr-aiaaa-aaaah-abqiq-cai",
        "6kdwg-paaaa-aaaap-qbuea-cai",
        "6kk5l-syaaa-aaaaj-qau2q-cai",
        "6km5p-fiaaa-aaaah-qczxa-cai",
        "6nn33-iqaaa-aaaah-qczxq-cai",
        "6olkk-7iaaa-aaaah-qboaa-cai",
        "6pv4j-hqaaa-aaaag-qbhka-cai",
        "6qfxa-ryaaa-aaaai-qbhsq-cai",
        "6qlam-vaaaa-aaaah-abddq-cai",
        "6rjbk-7qaaa-aaaah-qczvq-cai",
        "6rw7t-qaaaa-aaaag-qcela-cai",
        "6sqoc-hyaaa-aaaag-qbt4q-cai",
        "6tjeq-waaaa-aaaah-qcvzq-cai",
        "6tw2j-zqaaa-aaaag-qciha-cai",
        "6uguo-3iaaa-aaaag-qbyna-cai",
        "6ujx2-xiaaa-aaaak-qitea-cai",
        "6uuki-gqaaa-aaaag-qj3ka-cai",
        "6wghg-7yaaa-aaaam-qagra-cai",
        "6wgru-syaaa-aaaag-qbuba-cai",
        "6wih6-siaaa-aaaah-qczva-cai",
        "6wqte-zyaaa-aaaam-qazuq-cai",
        "6x2dy-zqaaa-aaaah-aecna-cai",
        "6ykkw-jyaaa-aaaah-qczua-cai",
        "7324y-zaaaa-aaaal-qjhua-cai",
        "736xk-wqaaa-aaaam-qazta-cai",
        "73xld-saaaa-aaaah-qbjya-cai",
        "73yov-xqaaa-aaaai-qpbcq-cai",
        "74iy7-xqaaa-aaaaf-qagra-cai",
        "74jto-qiaaa-aaaag-qbuga-cai",
        "76jwu-zyaaa-aaaag-qbyka-cai",
        "776km-iqaaa-aaaag-qbt3a-cai",
        "77bch-kaaaa-aaaan-qa4vq-cai",
        "7a355-biaaa-aaaag-qblbq-cai",
        "7aawj-2aaaa-aaaah-abxsq-cai",
        "7anj7-hiaaa-aaaag-qbuea-cai",
        "7cpyk-jyaaa-aaaag-qa5na-cai",
        "7eavq-7iaaa-aaaak-qjcqa-cai",
        "7fdjf-paaaa-aaaak-qitbq-cai",
        "7gayh-aqaaa-aaaah-abdgq-cai",
        "7gipp-tyaaa-aaaag-qdk2a-cai",
        "7gq5h-byaaa-aaaah-aeciq-cai",
        "7gvfz-3iaaa-aaaah-qcsbq-cai",
        "7hbq5-xyaaa-aaaah-abxsa-cai",
        "7hmpl-kqaaa-aaaag-qbueq-cai",
        "7i54s-nyaaa-aaaal-abomq-cai",
        "7lsq4-kyaaa-aaaah-aclvq-cai",
        "7lyt3-6qaaa-aaaag-qbhma-cai",
        "7mi54-4iaaa-aaaag-qcxga-cai",
        "7n5cp-tiaaa-aaaal-qdjhq-cai",
        "7no7f-paaaa-aaaam-qa6nq-cai",
        "7oxg7-2iaaa-aaaah-qcguq-cai",
        "7qjpt-fiaaa-aaaag-qa5oa-cai",
        "7qno3-maaaa-aaaak-qt5pq-cai",
        "7rktg-vaaaa-aaaag-qbm7q-cai",
        "7rozc-oyaaa-aaaag-qjq5a-cai",
        "7sfim-liaaa-aaaah-qczta-cai",
        "7ush6-3iaaa-aaaak-qiu7q-cai",
        "7vkys-gaaaa-aaaag-qbuhq-cai",
        "7wlda-vyaaa-aaaam-qa6pa-cai",
        "7x4jk-jqaaa-aaaag-qbhoa-cai",
        "7yjoi-oiaaa-aaaam-qa6oa-cai",
        "7yoel-kiaaa-aaaag-qcdra-cai",
        "7yx3q-waaaa-aaaah-ad2ha-cai",
        "a2g7g-ayaaa-aaaag-qbwna-cai",
        "a2qle-gyaaa-aaaag-qbjiq-cai",
        "a6gca-6yaaa-aaaam-qa4fa-cai",
        "a7aaz-nqaaa-aaaag-qcvoq-cai",
        "a7ady-jiaaa-aaaah-arexa-cai",
        "a7h4i-eqaaa-aaaag-qb2bq-cai",
        "aahdh-diaaa-aaaag-qdira-cai",
        "aak4r-6aaaa-aaaah-adlhq-cai",
        "acu2b-cyaaa-aaaag-qbrsq-cai",
        "adezj-6iaaa-aaaah-areva-cai",
        "adqze-7iaaa-aaaah-aq6vq-cai",
        "af3kp-7qaaa-aaaao-aaxgq-cai",
        "afdix-jaaaa-aaaag-qboxq-cai",
        "afeug-aaaaa-aaaag-qcbyq-cai",
        "afeuw-qaaaa-aaaap-aakya-cai",
        "aguhh-4yaaa-aaaam-qa32q-cai",
        "ah2fs-fqaaa-aaaak-aalya-cai",
        "ah6x3-4qaaa-aaaah-aeada-cai",
        "ahl3d-xqaaa-aaaaj-qacca-cai",
        "ahos3-5yaaa-aaaah-abbna-cai",
        "aiai7-miaaa-aaaag-qbwoa-cai",
        "aitud-eiaaa-aaaag-qddbq-cai",
        "aiw45-kiaaa-aaaag-qbjlq-cai",
        "ajjxn-iiaaa-aaaah-adlga-cai",
        "akczk-cyaaa-aaaag-qa7ha-cai",
        "albtn-7qaaa-aaaam-qa4gq-cai",
        "algz6-lqaaa-aaaap-aakza-cai",
        "algzo-3qaaa-aaaag-qcbzq-cai",
        "amaup-gaaaa-aaaal-qb6dq-cai",
        "amrli-aiaaa-aaaap-aav4a-cai",
        "arcoq-syaaa-aaaah-arewa-cai",
        "arttq-uaaaa-aaaam-qaxva-cai",
        "aseks-myaaa-aaaam-qaqia-cai",
        "attwk-5qaaa-aaaam-qa3za-cai",
        "aueso-3iaaa-aaaag-qbwma-cai",
        "auggb-4iaaa-aaaag-qatja-cai",
        "ausgm-5iaaa-aaaag-qbjjq-cai",
        "awbbf-xqaaa-aaaai-qieaa-cai",
        "ax4iy-pqaaa-aaaak-qi2ya-cai",
        "axcd7-mqaaa-aaaag-qcb3q-cai",
        "axwuw-uyaaa-aaaal-qdloq-cai",
        "ayhr5-6qaaa-aaaam-acdwq-cai",
        "ayvgq-riaaa-aaaap-abeoa-cai",
        "az5sd-cqaaa-aaaae-aaarq-cai",
        "azdpg-4qaaa-aaaal-qjccq-cai",
        "azsqr-kyaaa-aaaag-qkc5q-cai",
        "b2mhr-dyaaa-aaaag-qcb4a-cai",
        "b2vyk-7qaaa-aaaah-adyka-cai",
        "b4mk6-5qaaa-aaaah-arerq-cai",
        "b547e-maaaa-aaaam-qadga-cai",
        "b5el6-hqaaa-aaaah-qcdhq-cai",
        "b5nbf-oaaaa-aaaag-qcb4q-cai",
        "b6lqu-zyaaa-aaaag-qbwla-cai",
        "b7s2g-iaaaa-aaaah-qcqoa-cai",
        "bapzn-kiaaa-aaaam-qaiva-cai",
        "bbyth-waaaa-aaaag-qbrua-cai",
        "bcz6h-iyaaa-aaaag-qbjmq-cai",
        "bepel-uiaaa-aaaag-qbc5a-cai",
        "bfyob-iaaaa-aaaam-qa34a-cai",
        "bgi5q-eyaaa-aaaap-aak6q-cai",
        "bgnv6-2yaaa-aaaag-qalua-cai",
        "bi3y3-aiaaa-aaaag-qbrvq-cai",
        "bid2t-gyaaa-aaaah-qcdea-cai",
        "bjcsj-rqaaa-aaaah-qcxqq-cai",
        "bk5uo-miaaa-aaaal-qiulq-cai",
        "bkvll-jiaaa-aaaah-qcqnq-cai",
        "blewr-lyaaa-aaaah-ad7ua-cai",
        "bm3f5-6iaaa-aaaam-qa35q-cai",
        "bm3tp-tiaaa-aaaag-qbjnq-cai",
        "bmk34-4iaaa-aaaag-qczha-cai",
        "bp26p-nqaaa-aaaag-qbrva-cai",
        "bp5co-uqaaa-aaaap-aav2q-cai",
        "brx5n-xqaaa-aaaan-qanqa-cai",
        "bsdmf-gyaaa-aaaak-acgka-cai",
        "btggw-4aaaa-aaaah-qcdgq-cai",
        "btiq4-4qaaa-aaaag-qbosq-cai",
        "buja2-4iaaa-aaaam-qa4ca-cai",
        "bvckr-laaaa-aaaak-acgkq-cai",
        "bx6pk-jqaaa-aaaag-qbjpa-cai",
        "bxdf4-baaaa-aaaah-qaruq-cai",
        "bxsmj-kiaaa-aaaaj-aai3a-cai",
        "byowe-niaaa-aaaag-qdiva-cai",
        "bzsui-sqaaa-aaaah-qce2a-cai",
        "c37l7-eqaaa-aaaag-qbwaq-cai",
        "c77al-xqaaa-aaaag-qboyq-cai",
        "c77wz-2qaaa-aaaam-qa4iq-cai",
        "c7fao-laaaa-aaaae-aaa4q-cai",
        "c7y4k-oqaaa-aaaap-aakxa-cai",
        "ca4b4-uyaaa-aaaal-aac7a-cai",
        "caij4-dqaaa-aaaag-qjvfa-cai",
        "cchps-gaaaa-aaaak-qasaa-cai",
        "cd3mi-nqaaa-aaaam-qa4kq-cai",
        "cdnz4-7yaaa-aaaal-qbbkq-cai",
        "cdvmq-aaaaa-aaaah-qcdoq-cai",
        "ce2k4-aiaaa-aaaam-qa4ka-cai",
        "ce6wk-wqaaa-aaaag-qjsyq-cai",
        "cec6g-lyaaa-aaaah-qc4lq-cai",
        "cf4le-xyaaa-aaaah-areya-cai",
        "chnfm-vqaaa-aaaag-qbjha-cai",
        "cib4d-2iaaa-aaaak-aaluq-cai",
        "cihkf-qyaaa-aaaah-qb7jq-cai",
        "ck7nx-7yaaa-aaaag-qcbua-cai",
        "ckbgq-4yaaa-aaaak-qi2xq-cai",
        "ckiml-viaaa-aaaal-qiymq-cai",
        "ckwhm-wiaaa-aaaah-qcdpa-cai",
        "ckyrg-wyaaa-aaaag-qbo3a-cai",
        "cl6fn-iqaaa-aaaag-qcvaq-cai",
        "cl6gm-miaaa-aaaah-areza-cai",
        "cm2lh-liaaa-aaaag-qa7ka-cai",
        "cn47m-vaaaa-aaaag-qderq-cai",
        "cnhuy-oiaaa-aaaah-adycq-cai",
        "cnxby-3qaaa-aaaah-qcdpq-cai",
        "cokeu-yaaaa-aaaag-qjvea-cai",
        "cppgk-uqaaa-aaaag-qb5sa-cai",
        "cqkhj-qiaaa-aaaam-qaxyq-cai",
        "crt3j-mqaaa-aaaah-qcdnq-cai",
        "ctt6t-faaaa-aaaah-qcpbq-cai",
        "cuioa-jiaaa-aaaag-qayvq-cai",
        "cv22g-waaaa-aaaag-qczoq-cai",
        "cv5gx-7aaaa-aaaag-qbwbq-cai",
        "cvlsv-zaaaa-aaaag-qbjea-cai",
        "cw4lx-byaaa-aaaag-qboza-cai",
        "cwu5z-wyaaa-aaaaj-qaoaq-cai",
        "cwzdj-pyaaa-aaaag-qdeta-cai",
        "cx245-3iaaa-aaaah-are3a-cai",
        "cx7xc-rqaaa-aaaag-qa7iq-cai",
        "cxlb5-5qaaa-aaaam-qaxya-cai",
        "cy2m3-bqaaa-aaaag-qjs2q-cai",
        "czjmv-gaaaa-aaaam-qaxza-cai",
        "czogw-caaaa-aaaag-qckga-cai",
        "d26yv-eqaaa-aaaah-abz4q-cai",
        "d3ttm-qaaaa-aaaai-qam4a-cai",
        "d5mc5-biaaa-aaaah-admtq-cai",
        "dahor-xyaaa-aaaal-qiylq-cai",
        "daqp5-niaaa-aaaap-aaktq-cai",
        "davht-tiaaa-aaaag-qalza-cai",
        "dawzl-xyaaa-aaaal-advoa-cai",
        "dbnqs-yiaaa-aaaah-abg3q-cai",
        "dcbuw-wyaaa-aaaam-qapfq-cai",
        "deb2y-miaaa-aaaam-qa3rq-cai",
        "dezoc-hyaaa-aaaah-qc3qa-cai",
        "dfcq7-raaaa-aaaag-qayqa-cai",
        "dhiaa-ryaaa-aaaae-qabva-cai",
        "dhoxa-7aaaa-aaaah-qc4na-cai",
        "dhyds-jaaaa-aaaao-aaiia-cai",
        "dispk-yqaaa-aaaah-are7q-cai",
        "djk3k-xiaaa-aaaah-adyeq-cai",
        "djkni-kiaaa-aaaae-qabua-cai",
        "djuya-caaaa-aaaag-qbo5q-cai",
        "dkdbc-2yaaa-aaaag-qbjaq-cai",
        "dknxi-2iaaa-aaaah-qceuq-cai",
        "dkt4p-ziaaa-aaaal-qi7xa-cai",
        "dqhdp-2iaaa-aaaam-qapgq-cai",
        "dqzxr-giaaa-aaaaj-qackq-cai",
        "drbbg-zaaaa-aaaap-aannq-cai",
        "dsamw-xyaaa-aaaag-qc6vq-cai",
        "dsref-yyaaa-aaaag-qbo7a-cai",
        "dtlqp-nqaaa-aaaak-abwna-cai",
        "dtopv-2yaaa-aaaah-admsq-cai",
        "duh6j-eiaaa-aaaag-qbfoq-cai",
        "dur4z-piaaa-aaaam-qai3a-cai",
        "dv6u3-vqaaa-aaaah-qcdlq-cai",
        "dwzyz-yqaaa-aaaah-ad73q-cai",
        "dxehg-5qaaa-aaaag-qayta-cai",
        "dylar-wyaaa-aaaah-qcexq-cai",
        "e2pqa-nyaaa-aaaah-abs5q-cai",
        "e2ung-3qaaa-aaaam-qa46q-cai",
        "e3izy-jiaaa-aaaah-qacbq-cai",
        "e3mmv-5qaaa-aaaah-aadma-cai",
        "e4ca6-oiaaa-aaaai-acm2a-cai",
        "e4ex6-aqaaa-aaaal-aarca-cai",
        "e5djc-5iaaa-aaaag-qbrlq-cai",
        "e5owu-aaaaa-aaaah-abs5a-cai",
        "e6uqa-fqaaa-aaaag-qbwwq-cai",
        "e7jp7-aqaaa-aaaah-acr6a-cai",
        "e7xmv-vyaaa-aaaag-qahha-cai",
        "e7z3z-raaaa-aaaaj-aadwa-cai",
        "eagn3-qaaaa-aaaam-qaxna-cai",
        "eb7r3-myaaa-aaaah-qcdya-cai",
        "ebkmf-xaaaa-aaaah-abs7a-cai",
        "ebrrd-biaaa-aaaam-qa44a-cai",
        "ebtt6-liaaa-aaaag-qalja-cai",
        "ecqkr-sqaaa-aaaag-qbwuq-cai",
        "edhwj-dyaaa-aaaag-qb5fq-cai",
        "edzvd-wqaaa-aaaah-adl4q-cai",
        "eejma-naaaa-aaaak-aalda-cai",
        "efaew-qiaaa-aaaag-qcg6q-cai",
        "efbpx-hqaaa-aaaam-ab7ja-cai",
        "efoeo-5yaaa-aaaan-qaz2q-cai",
        "egsvk-gqaaa-aaaag-qaljq-cai",
        "ehr7n-3yaaa-aaaam-qaiia-cai",
        "ems7u-lyaaa-aaaal-qnbma-cai",
        "enae3-paaaa-aaaal-qdh3a-cai",
        "eosur-nqaaa-aaaam-qaijq-cai",
        "ep54t-xiaaa-aaaah-qcdza-cai",
        "epmcs-viaaa-aaaan-qabdq-cai",
        "eptkz-xyaaa-aaaag-qbona-cai",
        "epxa5-maaaa-aaaag-qjspq-cai",
        "er7d4-6iaaa-aaaaj-qac2q-cai",
        "erfen-7aaaa-aaaap-ahniq-cai",
        "erpx2-pyaaa-aaaah-qcqsq-cai",
        "etbek-gyaaa-aaaag-qbrkq-cai",
        "ett5d-6yaaa-aaaar-a3wnq-cai",
        "ey3ct-4aaaa-aaaak-aaueq-cai",
        "eze6x-xiaaa-aaaap-aan4a-cai",
        "f354x-baaaa-aaaah-aqzxq-cai",
        "f4elk-2aaaa-aaaah-aea4a-cai",
        "f5omc-taaaa-aaaai-acaqq-cai",
        "f5ybl-tqaaa-aaaal-qnbjq-cai",
        "f5yzg-riaaa-aaaag-qbwqa-cai",
        "f6bwo-jaaaa-aaaah-qc4za-cai",
        "fab4i-diaaa-aaaah-acr2q-cai",
        "fc5ox-yqaaa-aaaag-qbokq-cai",
        "fc5yf-vqaaa-aaaam-qa42q-cai",
        "fcsoj-yiaaa-aaaar-an2mq-cai",
        "fdcfh-2qaaa-aaaah-admha-cai",
        "feq7p-7iaaa-aaaah-abzia-cai",
        "ff3uc-miaaa-aaaap-aakfq-cai",
        "fg5fd-lqaaa-aaaag-qbwsq-cai",
        "fi7il-qaaaa-aaaag-qbwtq-cai",
        "fi7qg-syaaa-aaaal-qnbka-cai",
        "fioai-paaaa-aaaap-aanzq-cai",
        "fjhio-ciaaa-aaaak-aaleq-cai",
        "fjz4q-6iaaa-aaaap-aagiq-cai",
        "fkntx-eiaaa-aaaag-qjzyq-cai",
        "fl5nr-xiaaa-aaaai-qbjmq-cai",
        "fl6tz-dyaaa-aaaam-qa43a-cai",
        "fm7vn-oaaaa-aaaam-qa43q-cai",
        "fnzxe-niaaa-aaaap-aa6qq-cai",
        "fojcx-iaaaa-aaaap-qhmbq-cai",
        "fooog-vqaaa-aaaap-aaznq-cai",
        "fpimp-wyaaa-aaaam-qa3gq-cai",
        "fryf3-eiaaa-aaaag-qa7ya-cai",
        "ft6xr-taaaa-aaaam-aafmq-cai",
        "fvsni-daaaa-aaaah-adlzq-cai",
        "fx272-zyaaa-aaaag-qboja-cai",
        "fx5d3-ayaaa-aaaap-aakgq-cai",
        "fx6v6-caaaa-aaaag-qjslq-cai",
        "fxe4q-mqaaa-aaaah-adyqa-cai",
        "fzogq-eiaaa-aaaag-qbrnq-cai",
        "g3vnf-uiaaa-aaaah-qc4sq-cai",
        "g3yn2-gaaaa-aaaag-qkcla-cai",
        "g4253-zaaaa-aaaag-qbrga-cai",
        "g4o5w-yaaaa-aaaag-qalgq-cai",
        "g53vb-oiaaa-aaaag-qbfsq-cai",
        "g5dxj-iyaaa-aaaah-qcxda-cai",
        "g5pvm-piaaa-aaaag-qa7sa-cai",
        "g73gj-kyaaa-aaaam-qa3oq-cai",
        "g73q3-hyaaa-aaaag-qbj6q-cai",
        "gaiti-iaaaa-aaaag-qbobq-cai",
        "gan2q-ciaaa-aaaai-aanoq-cai",
        "gappj-raaaa-aaaap-aakoa-cai",
        "gdeb6-lqaaa-aaaah-abvpq-cai",
        "ge4yr-2aaaa-aaaag-qamza-cai",
        "gevsk-tqaaa-aaaah-qaoca-cai",
        "gfcya-pyaaa-aaaan-qbxda-cai",
        "gfjqg-miaaa-aaaag-qbcna-cai",
        "gfmyy-ciaaa-aaaag-qdiha-cai",
        "gh7b6-dyaaa-aaaag-qbreq-cai",
        "ghjdo-iyaaa-aaaam-qa4ra-cai",
        "ghqck-pyaaa-aaaak-qi2nq-cai",
        "ghxmp-xiaaa-aaaao-ba4sq-cai",
        "gi4em-paaaa-aaaag-qbfra-cai",
        "gi72u-lqaaa-aaaal-ac3ga-cai",
        "gijow-nqaaa-aaaal-acedq-cai",
        "gikg4-eaaaa-aaaam-qaieq-cai",
        "gikqo-jaaaa-aaaag-qb2uq-cai",
        "gj2qh-riaaa-aaaag-qc6kq-cai",
        "gjlyu-6iaaa-aaaag-qboaa-cai",
        "gjv36-laaaa-aaaah-adyza-cai",
        "gk4xe-lqaaa-aaaam-qa3na-cai",
        "gkhkc-5yaaa-aaaah-abvoa-cai",
        "gksxm-waaaa-aaaao-aapjq-cai",
        "gl5jm-ryaaa-aaaag-qb5jq-cai",
        "gll5o-xyaaa-aaaag-qbcma-cai",
        "glx23-baaaa-aaaao-aeatq-cai",
        "glzmr-bqaaa-aaaap-ahnhq-cai",
        "gm4py-4aaaa-aaaag-qb5ja-cai",
        "gn5hc-liaaa-aaaag-qbj5q-cai",
        "goei2-daaaa-aaaao-aaiua-cai",
        "goikp-uqaaa-aaaag-qalfq-cai",
        "goncb-kqaaa-aaaap-aakpa-cai",
        "gp4jz-vaaaa-aaaam-ac4ga-cai",
        "gpjcv-dyaaa-aaaag-qa7ra-cai",
        "gq5kt-4iaaa-aaaal-qdhuq-cai",
        "gq7ji-saaaa-aaaap-aazeq-cai",
        "grh6z-jaaaa-aaaah-ad7gq-cai",
        "gsnnn-ziaaa-aaaag-acaaa-cai",
        "gsyqt-cqaaa-aaaag-qbrha-cai",
        "gtb2b-tiaaa-aaaah-qcxca-cai",
        "gtiqk-kyaaa-aaaap-aa6zq-cai",
        "guy65-yaaaa-aaaag-qbfta-cai",
        "gw7hg-iqaaa-aaaap-aanqq-cai",
        "gxph7-ayaaa-aaaag-qbcoa-cai",
        "gyuaf-kqaaa-aaaah-qceka-cai",
        "gz2dw-xqaaa-aaaap-qb5nq-cai",
        "gzn5t-caaaa-aaaal-qbs2q-cai",
        "h3all-yyaaa-aaaag-qbw5a-cai",
        "h3ixe-raaaa-aaaar-aonua-cai",
        "h4gro-4aaaa-aaaag-qczsq-cai",
        "h5aet-waaaa-aaaab-qaamq-cai",
        "h7aa7-lyaaa-aaaag-qbofa-cai",
        "hafxo-caaaa-aaaag-qbw7q-cai",
        "hbe7u-viaaa-aaaag-qbcla-cai",
        "hc3r6-6yaaa-aaaah-admkq-cai",
        "hcsnx-2iaaa-aaaam-ac4bq-cai",
        "hctgw-nqaaa-aaaag-qbfwa-cai",
        "hdxhu-qqaaa-aaaai-aasnq-cai",
        "he2ur-tqaaa-aaaan-qabja-cai",
        "hfswq-niaaa-aaaam-qaxgq-cai",
        "hgfza-yqaaa-aaaag-qbclq-cai",
        "hhce5-bqaaa-aaaak-qtt3q-cai",
        "hhsfy-jyaaa-aaaag-qbj2q-cai",
        "hhwp4-saaaa-aaaag-qjvya-cai",
        "hihui-daaaa-aaaag-qbckq-cai",
        "hirak-faaaa-aaaag-qb5pa-cai",
        "hjg4s-uiaaa-aaaag-qbw6a-cai",
        "hjq6c-7iaaa-aaaam-qa3lq-cai",
        "hjqiq-siaaa-aaaag-qbj3q-cai",
        "hjuvq-qyaaa-aaaal-qjfmq-cai",
        "hkff5-nqaaa-aaaag-qaldq-cai",
        "hlzav-7qaaa-aaaak-afn2a-cai",
        "hmvb2-nyaaa-aaaag-qjzvq-cai",
        "hnedj-aiaaa-aaaag-qalda-cai",
        "hoh2g-zqaaa-aaaag-qbw6q-cai",
        "hovea-eiaaa-aaaag-qjvzq-cai",
        "hqvh5-maaaa-aaaam-qaxfa-cai",
        "hqvrp-baaaa-aaaag-qbfva-cai",
        "hse4g-hqaaa-aaaag-qcztq-cai",
        "hvf2s-kiaaa-aaaag-qczta-cai",
        "hvgd6-taaaa-aaaap-ahgsa-cai",
        "hvusb-fiaaa-aaaag-qbjzq-cai",
        "hxaxw-nyaaa-aaaag-qa7va-cai",
        "hxx6h-raaaa-aaaag-aclxa-cai",
        "hybqz-laaaa-aaaam-qa4vq-cai",
        "hz6n3-eaaaa-aaaah-admia-cai",
        "hzc26-wiaaa-aaaag-qa7ua-cai",
        "hzuo4-qiaaa-aaaag-qaarq-cai",
        "hzw2t-xiaaa-aaaag-qbfuq-cai",
        "i2xig-xaaaa-aaaam-qa2oa-cai",
        "i3ll4-4qaaa-aaaak-qaueq-cai",
        "i5a2q-4yaaa-aaaam-qafla-cai",
        "i5gfn-uiaaa-aaaal-qi6ja-cai",
        "i6bbc-paaaa-aaaag-qbpdq-cai",
        "ia35d-eyaaa-aaaah-advuq-cai",
        "ibeab-lyaaa-aaaam-qafja-cai",
        "ibewt-gyaaa-aaaag-qbxza-cai",
        "ibscr-ayaaa-aaaag-qbi4q-cai",
        "igtef-naaaa-aaaag-qbi4a-cai",
        "iih5p-qqaaa-aaaag-qbxyq-cai",
        "iiibs-tqaaa-aaaak-aab6q-cai",
        "iirjn-wqaaa-aaaag-qbi5a-cai",
        "ijyw7-sqaaa-aaaah-advva-cai",
        "ilc2l-vqaaa-aaaag-qjtcq-cai",
        "ilqen-iiaaa-aaaag-qbqfq-cai",
        "imhw3-dqaaa-aaaag-qbpaq-cai",
        "iohft-haaaa-aaaam-qar4q-cai",
        "ipchn-lqaaa-aaaam-qizkq-cai",
        "ipqpz-3iaaa-aaaag-qbi5q-cai",
        "iqvyi-sqaaa-aaaag-qbqha-cai",
        "ircsc-oyaaa-aaaam-qajga-cai",
        "issbt-caaaa-aaaap-aayeq-cai",
        "itcxy-hiaaa-aaaam-qafka-cai",
        "itud2-biaaa-aaaam-qa2pq-cai",
        "iudh6-hqaaa-aaaag-qbx2q-cai",
        "iurzy-2iaaa-aaaag-qju5q-cai",
        "ivgzt-yyaaa-aaaau-agwma-cai",
        "iwduw-daaaa-aaaam-qajgq-cai",
        "ixck6-ziaaa-aaaag-qbpca-cai",
        "iybz6-yqaaa-aaaam-qajhq-cai",
        "iyzne-taaaa-aaaah-qcjga-cai",
        "j2ey6-baaaa-aaaaj-qap4a-cai",
        "j3az4-4aaaa-aaaah-abyhq-cai",
        "j3c2x-ciaaa-aaaak-aanxa-cai",
        "j3dqa-byaaa-aaaah-qcwfa-cai",
        "j4cwu-maaaa-aaaah-qcwfq-cai",
        "j5f6k-myaaa-aaaaj-qap4q-cai",
        "j663c-yyaaa-aaaag-qju2q-cai",
        "j7n3m-7iaaa-aaaam-qarza-cai",
        "j7znt-tiaaa-aaaag-qazjq-cai",
        "jc6lx-uaaaa-aaaag-qbi2a-cai",
        "jcgj7-sqaaa-aaaah-qc2lq-cai",
        "jcpde-3aaaa-aaaag-qcyqq-cai",
        "jd5xc-eiaaa-aaaag-qazlq-cai",
        "jeghr-iaaaa-aaaah-qco7q-cai",
        "jgacp-waaaa-aaaaj-qap6a-cai",
        "jgict-maaaa-aaaam-qa5xq-cai",
        "jh76l-5iaaa-aaaam-qawgq-cai",
        "jjeno-oyaaa-aaaak-aanua-cai",
        "jk4ir-vaaaa-aaaag-qb4pa-cai",
        "jkkkb-6aaaa-aaaam-qar2q-cai",
        "jlfcd-eyaaa-aaaah-qc2ka-cai",
        "jm4g7-pqaaa-aaaag-qbi3a-cai",
        "jmks5-jqaaa-aaaag-qbx6q-cai",
        "jmuqr-yqaaa-aaaaj-qaicq-cai",
        "jnosj-ayaaa-aaaap-abcaq-cai",
        "jntyp-yiaaa-aaaah-qcr3q-cai",
        "johir-5iaaa-aaaah-abyea-cai",
        "jouun-viaaa-aaaah-adnlq-cai",
        "jp36y-7aaaa-aaaak-qtvha-cai",
        "jpdjt-aiaaa-aaaaj-qap7q-cai",
        "jq4wk-diaaa-aaaag-qju3q-cai",
        "jqa6g-6aaaa-aaaah-qc2iq-cai",
        "jsjsg-2yaaa-aaaah-arfga-cai",
        "jsmzz-qaaaa-aaaag-qa6vq-cai",
        "jthtc-xiaaa-aaaaj-qap5q-cai",
        "jtpfm-aiaaa-aaaag-qbpea-cai",
        "jtzro-giaaa-aaaag-qbqbq-cai",
        "jugvw-2qaaa-aaaaj-qap5a-cai",
        "juovk-aqaaa-aaaam-qa5uq-cai",
        "juyx2-lqaaa-aaaag-qbqba-cai",
        "jv55j-riaaa-aaaal-abvnq-cai",
        "jvax7-zyaaa-aaaak-aanwa-cai",
        "jvli5-daaaa-aaaam-aainq-cai",
        "jwt4u-yaaaa-aaaah-aebqa-cai",
        "jx6g3-miaaa-aaaap-aamwa-cai",
        "jxpyk-6iaaa-aaaam-qafma-cai",
        "jxz22-viaaa-aaaag-qbizq-cai",
        "jzndq-iyaaa-aaaag-qbx5a-cai",
        "jznvc-fyaaa-aaaam-qafna-cai",
        "k2nwy-oaaaa-aaaag-qazca-cai",
        "k2pcx-jaaaa-aaaag-qb4ha-cai",
        "k3o47-tiaaa-aaaam-qa2dq-cai",
        "k3okn-6iaaa-aaaag-qbitq-cai",
        "k3wif-yyaaa-aaaah-qc2ca-cai",
        "k3yi5-viaaa-aaaam-qafga-cai",
        "k4p2l-6qaaa-aaaam-qa2da-cai",
        "k4pmz-tqaaa-aaaag-qbita-cai",
        "k4qsa-4aaaa-aaaah-qbvnq-cai",
        "k4zy3-vqaaa-aaaag-qbxwq-cai",
        "k5osr-jyaaa-aaaam-qaoxq-cai",
        "k6ucx-biaaa-aaaah-abyma-cai",
        "k7h5q-jyaaa-aaaan-qaaaq-cai",
        "k7obz-niaaa-aaaag-qbqlq-cai",
        "ka5ck-cqaaa-aaaag-qbxuq-cai",
        "ka5uy-pqaaa-aaaam-qafeq-cai",
        "kafas-uaaaa-aaaao-aaofq-cai",
        "kbeiy-tiaaa-aaaah-qcrrq-cai",
        "kbk6s-tyaaa-aaaag-qb4fq-cai",
        "kd63f-3iaaa-aaaag-qakja-cai",
        "kdk3i-2iaaa-aaaag-qbqjq-cai",
        "kdnhz-tiaaa-aaaag-qc7gq-cai",
        "ke2v7-iqaaa-aaaap-aalda-cai",
        "kembn-6qaaa-aaaag-qc7ga-cai",
        "kgjmj-zaaaa-aaaag-qazaa-cai",
        "kgrph-3yaaa-aaaaj-aacuq-cai",
        "kh4e6-piaaa-aaaag-qbxua-cai",
        "khln7-dqaaa-aaaap-qbiwq-cai",
        "khssu-pyaaa-aaaah-qc2aa-cai",
        "kihde-faaaa-aaaah-qcrqa-cai",
        "kijvo-fqaaa-aaaag-qb4ea-cai",
        "kjq74-uiaaa-aaaah-qc2ba-cai",
        "kkbh4-7iaaa-aaaah-adzuq-cai",
        "kkjqu-maaaa-aaaag-qbqia-cai",
        "kn3k4-jyaaa-aaaag-qdfha-cai",
        "kn5ky-6iaaa-aaaai-qbikq-cai",
        "kn6cc-hyaaa-aaaag-qbpna-cai",
        "ko7zq-uaaaa-aaaam-qaffq-cai",
        "kojns-saaaa-aaaam-qa2aa-cai",
        "kss7i-hqaaa-aaaah-qbvmq-cai",
        "kt2l3-uiaaa-aaaam-qarta-cai",
        "ktlvk-giaaa-aaaap-aayja-cai",
        "l22ez-fqaaa-aaaah-qcwiq-cai",
        "l2cqd-oaaaa-aaaam-qawja-cai",
        "l52i2-lyaaa-aaaak-aan2a-cai",
        "l5lxn-5qaaa-aaaah-adnfa-cai",
        "l5vuh-iyaaa-aaaag-qb34a-cai",
        "l7dtn-kiaaa-aaaam-qa2fq-cai",
        "l7gnb-jiaaa-aaaag-qdc7q-cai",
        "lbrye-syaaa-aaaam-qajoa-cai",
        "lcgbg-kaaaa-aaaam-qaota-cai",
        "lcqve-maaaa-aaaam-qarwq-cai",
        "legpi-qqaaa-aaaam-qa2ha-cai",
        "lgqic-saaaa-aaaag-qb36q-cai",
        "lhq4n-3yaaa-aaaai-qaniq-cai",
        "lisfk-jqaaa-aaaag-qb37q-cai",
        "listy-eqaaa-aaaam-qajpq-cai",
        "lix2q-6yaaa-aaaal-qdbaa-cai",
        "ljfzs-yyaaa-aaaag-qbqoq-cai",
        "ljt3c-tyaaa-aaaam-qa53a-cai",
        "ljwfo-qyaaa-aaaag-qdfba-cai",
        "llf4i-riaaa-aaaag-qb4cq-cai",
        "llt6y-2iaaa-aaaam-qarxa-cai",
        "lmgot-3qaaa-aaaag-qazha-cai",
        "lmvs7-dqaaa-aaaap-aahia-cai",
        "lnu2v-eyaaa-aaaag-qcy4a-cai",
        "lom6m-3iaaa-aaaae-qaaca-cai",
        "lovxf-kaaaa-aaaap-aalea-cai",
        "lptvm-jiaaa-aaaam-qajpa-cai",
        "lqp4q-iqaaa-aaaak-aakga-cai",
        "lrb6f-ryaaa-aaaam-qa2eq-cai",
        "lrd4y-3yaaa-aaaag-qanrq-cai",
        "lt2gz-oaaaa-aaaah-abylq-cai",
        "luw73-6qaaa-aaaag-qb35q-cai",
        "lvbdd-pyaaa-aaaag-qbqmq-cai",
        "lwayr-4aaaa-aaaam-qa2ea-cai",
        "lwkne-fiaaa-aaaah-acenq-cai",
        "lxbgz-giaaa-aaaag-qb4aq-cai",
        "lxmol-ciaaa-aaaak-abpdq-cai",
        "lycvz-hqaaa-aaaam-qa2fa-cai",
        "lyl7c-oaaaa-aaaan-qay6a-cai",
        "lzdlr-5yaaa-aaaag-qb4bq-cai",
        "lzhom-nqaaa-aaaap-ahmpq-cai",
        "m2nno-7aaaa-aaaah-adzba-cai",
        "m4fui-wyaaa-aaaag-qbejq-cai",
        "m5vub-oqaaa-aaaag-qcaxq-cai",
        "m6fha-siaaa-aaaam-qa2vq-cai",
        "m6frs-7iaaa-aaaag-qbifq-cai",
        "m7ezi-iaaaa-aaaag-qb4ra-cai",
        "m7vrl-xaaaa-aaaap-aah3a-cai",
        "maboz-byaaa-aaaag-qbelq-cai",
        "mbirl-fyaaa-aaaah-adzdq-cai",
        "mc7ij-5aaaa-aaaah-ad66q-cai",
        "mcquu-6aaaa-aaaal-qciyq-cai",
        "meqn6-5yaaa-aaaag-qcmza-cai",
        "mfa3f-iqaaa-aaaam-qa2xa-cai",
        "mfhqa-iyaaa-aaaai-abona-cai",
        "mgjwz-miaaa-aaaaj-qaqga-cai",
        "mivz5-gyaaa-aaaag-qbp3a-cai",
        "mk2a2-miaaa-aaaak-aavra-cai",
        "mk3kn-pyaaa-aaaah-qcoda-cai",
        "ml2cx-yqaaa-aaaah-qc2xq-cai",
        "mmdgl-tyaaa-aaaag-qbigq-cai",
        "mnjaf-6qaaa-aaaah-aebpa-cai",
        "mntgc-lqaaa-aaaag-qcmyq-cai",
        "mnu2t-cqaaa-aaaag-qbdxq-cai",
        "mo5a3-paaaa-aaaah-adstq-cai",
        "moi6e-qaaaa-aaaag-atsna-cai",
        "mpk5f-2aaaa-aaaaj-qaqhq-cai",
        "mqkdm-zqaaa-aaaah-ablsa-cai",
        "mqriy-cyaaa-aaaag-qbxba-cai",
        "mreap-uqaaa-aaaag-qazva-cai",
        "mrgeq-xaaaa-aaaap-qhntq-cai",
        "mrgua-tqaaa-aaaag-qb4qa-cai",
        "mrqac-vqaaa-aaaag-qbdvq-cai",
        "mtuyy-6qaaa-aaaal-qjdoq-cai",
        "mupba-ayaaa-aaaaj-qaqfa-cai",
        "mxmzj-5iaaa-aaaah-ace5q-cai",
        "mxyze-4iaaa-aaaah-ad65a-cai",
        "mytl6-dyaaa-aaaag-qbdua-cai",
        "myuxp-kyaaa-aaaag-qcm3a-cai",
        "mzb7y-4qaaa-aaaag-qdcpa-cai",
        "n37cy-xaaaa-aaaag-qbdsq-cai",
        "n46em-2yaaa-aaaag-qbdsa-cai",
        "n46fk-6qaaa-aaaai-ackxa-cai",
        "n57mw-nqaaa-aaaag-qbxgq-cai",
        "n5mqk-fqaaa-aaaag-qdcja-cai",
        "n5yqx-uqaaa-aaaap-aatja-cai",
        "n66bw-tiaaa-aaaag-qbp6a-cai",
        "n6bj5-ryaaa-aaaan-qaaqq-cai",
        "n7ib3-4qaaa-aaaai-qagnq-cai",
        "nahel-ryaaa-aaaah-aebiq-cai",
        "nalvp-gaaaa-aaaah-arcda-cai",
        "nb3wh-2qaaa-aaaag-qbxeq-cai",
        "nbg4r-saaaa-aaaah-qap7a-cai",
        "nc2nv-jiaaa-aaaam-qa5ma-cai",
        "ncmpf-ciaaa-aaaag-qbqzq-cai",
        "nd4pm-2aaaa-aaaag-qcuhq-cai",
        "ndkfb-xiaaa-aaaai-qj7ia-cai",
        "ndnrn-yaaaa-aaaam-qaw5a-cai",
        "nembl-yyaaa-aaaag-qbenq-cai",
        "nf35t-jqaaa-aaaag-qbp4q-cai",
        "nfnjr-pqaaa-aaaag-qbqza-cai",
        "nfvlz-jaaaa-aaaah-qcciq-cai",
        "nges7-giaaa-aaaaj-qaiya-cai",
        "nhueu-daaaa-aaaak-aavwq-cai",
        "niojz-kyaaa-aaaag-qbiaq-cai",
        "njgly-uaaaa-aaaah-qb6pa-cai",
        "njzvb-3qaaa-aaaag-qbdrq-cai",
        "nk7hr-iqaaa-aaaah-arf7q-cai",
        "nkg3l-qaaaa-aaaah-adnqa-cai",
        "nlzgj-7aaaa-aaaam-qa5nq-cai",
        "nmilc-4iaaa-aaaal-qizkq-cai",
        "nmywp-7yaaa-aaaag-qbp5a-cai",
        "nn6cu-rqaaa-aaaap-aa7ga-cai",
        "nncvb-tyaaa-aaaah-abh2q-cai",
        "noxpi-viaaa-aaaak-aavxa-cai",
        "npz3p-baaaa-aaaag-qbxfq-cai",
        "nq42m-fyaaa-aaaam-qa5pa-cai",
        "nqcos-zyaaa-aaaaj-qaqda-cai",
        "nrlqg-zqaaa-aaaag-qbeoa-cai",
        "nsbts-5iaaa-aaaah-aeblq-cai",
        "nu4hk-3yaaa-aaaag-qbxha-cai",
        "nusra-3iaaa-aaaah-qc2ta-cai",
        "nwkaa-ziaaa-aaaam-qaw6q-cai",
        "nwsau-hiaaa-aaaar-ahzfq-cai",
        "nwyv2-gaaaa-aaaaj-arc2a-cai",
        "nyph3-wyaaa-aaaap-aaaaa-cai",
        "nzbfo-pqaaa-aaaaj-qaqcq-cai",
        "o3kmp-daaaa-aaaam-qa5fq-cai",
        "o4mai-2yaaa-aaaap-aal2q-cai",
        "o4v7d-wqaaa-aaaah-adzma-cai",
        "o5l7c-tiaaa-aaaaf-qajwq-cai",
        "o6lzt-kiaaa-aaaag-qbdza-cai",
        "o6wdf-wiaaa-aaaah-aebbq-cai",
        "o7ehd-5qaaa-aaaah-qc2zq-cai",
        "oapqk-zyaaa-aaaam-qa5ha-cai",
        "oazs2-syaaa-aaaag-qbqsq-cai",
        "obgzk-qyaaa-aaaah-ads7a-cai",
        "obm2n-eqaaa-aaaag-qa6gq-cai",
        "oby2a-fqaaa-aaaag-qbega-cai",
        "ocszu-biaaa-aaaah-aebdq-cai",
        "ocxbk-3yaaa-aaaah-qcrkq-cai",
        "odyji-baaaa-aaaam-qa22a-cai",
        "oeee4-qaaaa-aaaak-qaaeq-cai",
        "og4xl-cqaaa-aaaah-aq7va-cai",
        "ok3ug-2iaaa-aaaag-qbilq-cai",
        "ol244-naaaa-aaaag-qb47a-cai",
        "olmi6-laaaa-aaaag-qbd2q-cai",
        "oqais-viaaa-aaaan-qatta-cai",
        "os7fd-6iaaa-aaaag-qbqrq-cai",
        "osona-biaaa-aaaap-aal3q-cai",
        "osxej-qaaaa-aaaae-qaa5q-cai",
        "ou7ln-eyaaa-aaaag-qbefq-cai",
        "ouj7p-cyaaa-aaaag-qb3aa-cai",
        "owuqd-dyaaa-aaaah-qapxq-cai",
        "oxyoe-3yaaa-aaaaf-al4ka-cai",
        "oy5vn-3yaaa-aaaam-qa2yq-cai",
        "oylx5-qyaaa-aaaag-qbxna-cai",
        "p23mx-piaaa-aaaah-aebhq-cai",
        "p2jk4-qiaaa-aaaak-aavza-cai",
        "p2oje-wiaaa-aaaak-qlhza-cai",
        "p4een-yqaaa-aaaal-ai7uq-cai",
        "p4q27-cyaaa-aaaam-qa26q-cai",
        "p5jg7-6aaaa-aaaah-qcolq-cai",
        "p5rex-yqaaa-aaaag-qb42a-cai",
        "p6xlj-eaaaa-aaaai-qj7hq-cai",
        "pa6v3-mqaaa-aaaah-aceva-cai",
        "pacc6-6yaaa-aaaag-qbxja-cai",
        "par6c-wyaaa-aaaag-qdcgq-cai",
        "pauw4-yyaaa-aaaag-qbimq-cai",
        "pcatl-qiaaa-aaaag-qa6aa-cai",
        "pctry-taaaa-aaaai-qj7fq-cai",
        "pdgha-oaaaa-aaaag-qdf3q-cai",
        "pdv34-gaaaa-aaaag-qbqua-cai",
        "pi53o-dyaaa-aaaah-aebeq-cai",
        "pjsv6-aqaaa-aaaag-qdcha-cai",
        "pk6rk-6aaaa-aaaae-qaazq-cai",
        "pkasq-3iaaa-aaaam-qa5aa-cai",
        "pkhyd-piaaa-aaaap-aal7q-cai",
        "pkwqa-qiaaa-aaaag-qbqvq-cai",
        "plq2e-fiaaa-aaaai-qj7ea-cai",
        "pmc6d-lyaaa-aaaag-qa6ba-cai",
        "pmrc7-dyaaa-aaaag-qcloq-cai",
        "pnpu4-3aaaa-aaaah-qcceq-cai",
        "po6n2-uiaaa-aaaaj-qaiua-cai",
        "pooz4-fyaaa-aaaah-qc24a-cai",
        "pow3u-diaaa-aaaag-qbinq-cai",
        "poyn6-dyaaa-aaaah-qcfzq-cai",
        "pqvgb-7qaaa-aaaai-qj7gq-cai",
        "pqxpa-xaaaa-aaaah-aq7qa-cai",
        "pr32l-5qaaa-aaaaj-qaqoq-cai",
        "psaup-3aaaa-aaaak-qsxlq-cai",
        "puzb7-uyaaa-aaaah-aebgq-cai",
        "pvimf-cyaaa-aaaah-abu4a-cai",
        "pvu3q-aqaaa-aaaap-aamaq-cai",
        "pwskr-hiaaa-aaaag-qbqxq-cai",
        "px5ub-qqaaa-aaaah-qcjxa-cai",
        "pycz7-baaaa-aaaag-qjtrq-cai",
        "pzd64-5yaaa-aaaap-ahljq-cai",
        "q3nxc-eyaaa-aaaah-aq2ha-cai",
        "q3zuo-baaaa-aaaag-qcr6a-cai",
        "q4yr3-iaaaa-aaaah-araha-cai",
        "q4ys2-myaaa-aaaag-qcr6q-cai",
        "q56gr-sqaaa-aaaag-qbkfa-cai",
        "q5fnf-jyaaa-aaaah-abwwa-cai",
        "q5gez-uaaaa-aaaah-qcyuq-cai",
        "q5ist-uqaaa-aaaag-qbvaq-cai",
        "q6hjz-kyaaa-aaaah-qcama-cai",
        "q6usb-paaaa-aaaak-ae7va-cai",
        "q6v7s-biaaa-aaaak-acorq-cai",
        "q6yae-4aaaa-aaaal-qcnha-cai",
        "qa4il-3yaaa-aaaag-qcr4q-cai",
        "qbbxu-6yaaa-aaaah-abwua-cai",
        "qbc6i-daaaa-aaaah-qcywq-cai",
        "qc3ra-3iaaa-aaaag-qbs7q-cai",
        "qca2u-aaaaa-aaaah-abomq-cai",
        "qcg3w-tyaaa-aaaah-qakea-cai",
        "qdsos-7iaaa-aaaah-adpxq-cai",
        "qekxn-6yaaa-aaaap-aa5bq-cai",
        "qfmve-5qaaa-aaaam-qa7kq-cai",
        "qftl5-saaaa-aaaan-qacua-cai",
        "qjwjm-eaaaa-aaaah-qctga-cai",
        "qjyju-jqaaa-aaaam-qamca-cai",
        "qklen-ryaaa-aaaal-abixa-cai",
        "qkzeu-xiaaa-aaaam-qau2q-cai",
        "qmpah-qqaaa-aaaal-ajabq-cai",
        "qoxpy-jyaaa-aaaah-qctgq-cai",
        "qqlej-4yaaa-aaaam-qa7ja-cai",
        "qqmo2-iyaaa-aaaap-aajwq-cai",
        "qrk2b-gqaaa-aaaag-qbznq-cai",
        "qt4lz-jaaaa-aaaag-qbkea-cai",
        "qtk73-paaaa-aaaag-qbvbq-cai",
        "qtywz-lqaaa-aaaal-qjgta-cai",
        "qv3zw-kqaaa-aaaap-aa27q-cai",
        "qxo6l-hyaaa-aaaag-qjr3a-cai",
        "qyjr5-qyaaa-aaaag-qbzma-cai",
        "r4e6p-jyaaa-aaaag-qbzka-cai",
        "r4lvw-tqaaa-aaaah-aa7zq-cai",
        "r5fwv-6qaaa-aaaag-qbn6q-cai",
        "r5tcx-yqaaa-aaaag-qbs3a-cai",
        "r6a6i-qaaaa-aaaap-ahfia-cai",
        "r6e3v-aiaaa-aaaag-qbvga-cai",
        "r6vtw-7iaaa-aaaap-aaoma-cai",
        "r75rh-rqaaa-aaaah-qctda-cai",
        "rb2hq-syaaa-aaaah-abrpq-cai",
        "rb7zm-byaaa-aaaae-qacva-cai",
        "rcabe-xiaaa-aaaag-qbvea-cai",
        "rfxts-4qaaa-aaaag-qbkba-cai",
        "rg6j2-raaaa-aaaah-ad3fa-cai",
        "rgm6h-oyaaa-aaaan-qcx5a-cai",
        "rhbck-taaaa-aaaag-qbziq-cai",
        "rhg63-2aaaa-aaaag-qcwhq-cai",
        "ri5pt-5iaaa-aaaan-qactq-cai",
        "rityp-jqaaa-aaaal-qcnca-cai",
        "riut2-zyaaa-aaaag-qbsyq-cai",
        "rldky-baaaa-aaaag-qbvfq-cai",
        "rln4s-bqaaa-aaaah-qcyrq-cai",
        "rmuo4-hyaaa-aaaam-qayqq-cai",
        "rmuyo-kyaaa-aaaag-qbkaq-cai",
        "rn2ta-rqaaa-aaaak-qiv5a-cai",
        "rnsmf-uqaaa-aaaag-qcr3a-cai",
        "rpdbm-saaaa-aaaag-qbn5q-cai",
        "rppv3-yqaaa-aaaan-qcx4q-cai",
        "rpvvo-uaaaa-aaaag-qbsya-cai",
        "rqgw5-3yaaa-aaaag-qbvha-cai",
        "rqiax-3iaaa-aaaah-qcyta-cai",
        "rqqc7-5yaaa-aaaag-qbkcq-cai",
        "rr6wy-jqaaa-aaaak-aaiqa-cai",
        "rrcvy-giaaa-aaaah-aq2aa-cai",
        "rsehi-viaaa-aaaag-qa4oa-cai",
        "rsjy6-iaaaa-aaaah-aa7yq-cai",
        "rug5j-iyaaa-aaaag-qbn7a-cai",
        "rvhvt-7qaaa-aaaag-qbzlq-cai",
        "rw623-hyaaa-aaaah-qctcq-cai",
        "rw7qm-eiaaa-aaaak-aaiqq-cai",
        "rxrsz-5aaaa-aaaam-qaysa-cai",
        "rxvzl-sqaaa-aaaal-qjgva-cai",
        "rztjd-lqaaa-aaaag-qbkda-cai",
        "s2fij-liaaa-aaaag-qa3zq-cai",
        "s36wu-5qaaa-aaaah-qcyzq-cai",
        "s4fgh-ryaaa-aaaag-qapnq-cai",
        "s4rgk-qyaaa-aaaag-qbvna-cai",
        "s4rro-jqaaa-aaaal-qbfyq-cai",
        "s6hwe-laaaa-aaaab-qaeba-cai",
        "s7bu5-yiaaa-aaaal-qcnkq-cai",
        "s7q5y-daaaa-aaaam-qa7fq-cai",
        "sbcwr-3qaaa-aaaam-qamoa-cai",
        "sbf4s-7qaaa-aaaag-qcrra-cai",
        "scxno-jiaaa-aaaag-qa4ga-cai",
        "sduhj-uaaaa-aaaam-qa7hq-cai",
        "seyiz-jqaaa-aaaah-abobq-cai",
        "sfclx-fqaaa-aaaag-qbgga-cai",
        "sfwl2-eqaaa-aaaag-qa4gq-cai",
        "shcy7-baaaa-aaaam-qay2a-cai",
        "shkzf-7iaaa-aaaah-addwq-cai",
        "shzfz-xiaaa-aaaah-abwza-cai",
        "si77b-4yaaa-aaaad-qbttq-cai",
        "sigxo-jyaaa-aaaag-qcrqq-cai",
        "sjybn-raaaa-aaaah-qcy2q-cai",
        "skjpp-haaaa-aaaae-qac7q-cai",
        "skx2h-piaaa-aaaag-qbnwa-cai",
        "slzze-ciaaa-aaaah-aa7ra-cai",
        "snc46-dqaaa-aaaag-qaxwa-cai",
        "snw4t-cqaaa-aaaag-qbnwq-cai",
        "sobtd-xiaaa-aaaam-qay3q-cai",
        "soxrt-4iaaa-aaaag-qbvoa-cai",
        "sqwrc-vqaaa-aaaal-qdd7q-cai",
        "sr4qi-vaaaa-aaaah-qcaaq-cai",
        "srggp-uqaaa-aaaag-qaxua-cai",
        "stv7j-vaaaa-aaaag-qcoxq-cai",
        "suks2-3yaaa-aaaak-qivuq-cai",
        "svjgc-5yaaa-aaaah-abj7q-cai",
        "svsnw-gqaaa-aaaag-qbvmq-cai",
        "swha3-ziaaa-aaaag-qaxuq-cai",
        "swlc6-6yaaa-aaaah-qc7fq-cai",
        "swtwe-viaaa-aaaam-qa7ea-cai",
        "swu4x-biaaa-aaaap-aaj3q-cai",
        "sxe4o-jaaaa-aaaag-qbgfa-cai",
        "syfnt-cyaaa-aaaag-qaxvq-cai",
        "syhes-kiaaa-aaaaj-azxda-cai",
        "szogo-byaaa-aaaah-adpyq-cai",
        "szsrl-tqaaa-aaaag-qa4eq-cai",
        "t2eok-gyaaa-aaaah-qclwq-cai",
        "t2mog-myaaa-aaaal-aas7q-cai",
        "t3drq-7iaaa-aaaae-qac2a-cai",
        "t3lq2-raaaa-aaaag-qbswa-cai",
        "t555s-uyaaa-aaaal-qbjsa-cai",
        "t576z-kqaaa-aaaag-qa4cq-cai",
        "t64re-6iaaa-aaaam-qatpa-cai",
        "t7l3o-caaaa-aaaag-qbkoa-cai",
        "tajq6-syaaa-aaaap-aaw3a-cai",
        "tbzqh-2qaaa-aaaag-qbzfq-cai",
        "tco7x-piaaa-aaaam-qamiq-cai",
        "tde7l-3qaaa-aaaah-qansa-cai",
        "tdh62-qaaaa-aaaak-qloka-cai",
        "tdpb7-vaaaa-aaaag-qbkma-cai",
        "te62g-3iaaa-aaaal-qi43a-cai",
        "teytj-6yaaa-aaaag-qbvja-cai",
        "tfitq-wqaaa-aaaap-aa2xq-cai",
        "tfpyv-wyaaa-aaaal-qbonq-cai",
        "tgwaz-xyaaa-aaaah-qcura-cai",
        "tgywt-xiaaa-aaaag-qbzfa-cai",
        "thn6e-baaaa-aaaag-qaxra-cai",
        "ti233-myaaa-aaaag-qbzea-cai",
        "tj3tb-3qaaa-aaaag-qbnqq-cai",
        "tjnhd-5qaaa-aaaag-qbsva-cai",
        "tkmkd-diaaa-aaaag-qbknq-cai",
        "tlpww-taaaa-aaaag-qa34a-cai",
        "tnvo7-iaaaa-aaaah-qcy4q-cai",
        "tpvlf-bqaaa-aaaah-qcuqq-cai",
        "trm6y-xqaaa-aaaag-qdafa-cai",
        "trn4c-ciaaa-aaaag-qjwnq-cai",
        "tskpj-aiaaa-aaaag-qaxsq-cai",
        "tvo7m-iyaaa-aaaai-qjjsa-cai",
        "twiqs-uiaaa-aaaag-qbkpq-cai",
        "tx72y-iaaaa-aaaam-qatoq-cai",
        "txr2a-fqaaa-aaaah-qcmkq-cai",
        "tz5ae-2yaaa-aaaai-aci2q-cai",
        "tzjbp-7qaaa-aaaag-qa37a-cai",
        "u23qv-paaaa-aaaag-qbndq-cai",
        "u2kyg-aaaaa-aaaag-qc5ja-cai",
        "u44c2-mqaaa-aaaap-aa5ya-cai",
        "u4zku-sqaaa-aaaag-qa4sq-cai",
        "u52at-pyaaa-aaaam-qa7ta-cai",
        "u5evl-xqaaa-aaaah-ad32a-cai",
        "u5mcd-eyaaa-aaaag-qbsgq-cai",
        "u6npd-2aaaa-aaaag-qbk6a-cai",
        "ub6mq-vyaaa-aaaag-qbnba-cai",
        "ubap2-aqaaa-aaaah-ad3ya-cai",
        "uc7bq-laaaa-aaaag-qbvzq-cai",
        "ucxwy-yiaaa-aaaah-ad4fa-cai",
        "udkjh-5iaaa-aaaag-qa3nq-cai",
        "ufitg-ayaaa-aaaag-qbk4q-cai",
        "ufmrp-niaaa-aaaal-ab3eq-cai",
        "ufn3y-oyaaa-aaaag-qdawq-cai",
        "ugdkf-taaaa-aaaak-acoia-cai",
        "uh4wr-iiaaa-aaaag-qa4qa-cai",
        "uhabu-2aaaa-aaaah-adpma-cai",
        "ui5hm-dqaaa-aaaag-qbnaq-cai",
        "uilto-fqaaa-aaaag-qbsfa-cai",
        "uj63z-tyaaa-aaaag-qa4ra-cai",
        "uklwu-maaaa-aaaag-qb6ja-cai",
        "ukmkf-faaaa-aaaag-qcrga-cai",
        "ulnv3-laaaa-aaaal-qcvha-cai",
        "um5my-qqaaa-aaaag-qbvyq-cai",
        "umly2-wqaaa-aaaag-qbk5a-cai",
        "ummtp-gyaaa-aaaal-qcvhq-cai",
        "umqto-nyaaa-aaaah-abwoa-cai",
        "umv3q-dyaaa-aaaah-ad4ea-cai",
        "unssi-hiaaa-aaaah-qcmya-cai",
        "unzmm-zyaaa-aaaap-abagq-cai",
        "uo5jc-zaaaa-aaaag-qbzuq-cai",
        "upccs-3aaaa-aaaah-ad3za-cai",
        "uqpcl-bqaaa-aaaag-qbk7a-cai",
        "urjwa-7yaaa-aaaag-qcreq-cai",
        "usprd-faaaa-aaaam-qauda-cai",
        "utnz6-nqaaa-aaaag-qkbka-cai",
        "utopl-7iaaa-aaaag-qbshq-cai",
        "utve7-eaaaa-aaaah-abouq-cai",
        "uty3j-ziaaa-aaaag-qbnca-cai",
        "utyn3-uiaaa-aaaam-qa7sa-cai",
        "uu6bm-5qaaa-aaaag-qccnq-cai",
        "uuh6x-byaaa-aaaah-ad33q-cai",
        "uvxj2-ayaaa-aaaak-aapqa-cai",
        "uvyvh-dyaaa-aaaag-qbzwa-cai",
        "uxyq5-kiaaa-aaaag-qbv2a-cai",
        "uyk5m-zqaaa-aaaap-aa2fq-cai",
        "uz25v-ryaaa-aaaag-qbv3a-cai",
        "uzhxd-ziaaa-aaaah-qanaq-cai",
        "uzmjx-xyaaa-aaaag-qbk6q-cai",
        "v2awd-oaaaa-aaaam-qayia-cai",
        "v2ekv-yyaaa-aaaag-qjw2q-cai",
        "v3b6z-ziaaa-aaaam-qam4q-cai",
        "v3x4j-siaaa-aaaag-qbbja-cai",
        "v3zkd-syaaa-aaaah-qcm5a-cai",
        "v4jsw-5aaaa-aaaan-qaoha-cai",
        "v57fp-3qaaa-aaaah-ad4bq-cai",
        "v5bgf-oyaaa-aaaag-qbkyq-cai",
        "v5dsk-jyaaa-aaaag-qap5q-cai",
        "v5mzt-tqaaa-aaaah-abjoa-cai",
        "v6gck-vqaaa-aaaal-qi3sa-cai",
        "v6i4n-diaaa-aaaah-ad34q-cai",
        "v6rdg-paaaa-aaaap-aajka-cai",
        "v6wjv-3aaaa-aaaam-qa7vq-cai",
        "v7vsu-wqaaa-aaaai-qhpsa-cai",
        "vaec4-dqaaa-aaaam-qam6a-cai",
        "vcmg4-uiaaa-aaaah-ad36q-cai",
        "vdasr-2qaaa-aaaah-aq5fa-cai",
        "veq7x-4qaaa-aaaag-qa4wq-cai",
        "vesly-3qaaa-aaaag-qbztq-cai",
        "vfclr-dyaaa-aaaag-qc5nq-cai",
        "vffxa-kyaaa-aaaag-qbscq-cai",
        "vftdc-myaaa-aaaag-qbnha-cai",
        "vigb2-cqaaa-aaaam-qayla-cai",
        "vj752-6iaaa-aaaah-qcm6a-cai",
        "vjadt-byaaa-aaaap-aa2aa-cai",
        "vkqgq-aaaaa-aaaag-qbzsq-cai",
        "vlh2i-riaaa-aaaag-qbsdq-cai",
        "vlhm2-4iaaa-aaaam-qaatq-cai",
        "vmolu-pyaaa-aaaah-ad37q-cai",
        "vnpdo-yqaaa-aaaah-adpla-cai",
        "vqkrf-yyaaa-aaaah-ad35q-cai",
        "vqtoo-uqaaa-aaaap-aajla-cai",
        "vsaxy-faaaa-aaaag-qa3ia-cai",
        "vsf7w-3aaaa-aaaap-aa2cq-cai",
        "vt5ih-aaaaa-aaaah-ad4aq-cai",
        "vupsp-fyaaa-aaaah-abjpq-cai",
        "vvdfd-pyaaa-aaaag-qb6nq-cai",
        "vvvht-eyaaa-aaaam-qatya-cai",
        "vwc6r-4aaaa-aaaam-qaufa-cai",
        "w34hg-6aaaa-aaaah-ad3xa-cai",
        "w3tmp-uiaaa-aaaap-aawea-cai",
        "w4vw2-aqaaa-aaaag-qbsla-cai",
        "wakh7-myaaa-aaaah-abo2a-cai",
        "wdokm-kiaaa-aaaak-qlrsa-cai",
        "weht5-cqaaa-aaaag-qbvuq-cai",
        "wettq-dqaaa-aaaag-qapua-cai",
        "wfyyn-aqaaa-aaaah-adxza-cai",
        "wghwh-laaaa-aaaag-qbzyq-cai",
        "whcd5-6yaaa-aaaal-qjb3a-cai",
        "whdwd-siaaa-aaaag-qdhga-cai",
        "why5x-jaaaa-aaaah-ad3va-cai",
        "wjazr-4aaaa-aaaag-qjrpq-cai",
        "wkf6v-zaaaa-aaaag-qbvvq-cai",
        "wlea5-diaaa-aaaam-qatra-cai",
        "wpe53-5iaaa-aaaag-qbzza-cai",
        "wpgju-2iaaa-aaaag-qa44a-cai",
        "wrrkd-myaaa-aaaag-qcf5q-cai",
        "wug6o-kiaaa-aaaah-arhna-cai",
        "wvujj-ryaaa-aaaag-qaxpq-cai",
        "wwjtm-5iaaa-aaaah-ad4la-cai",
        "wwxqg-iaaaa-aaaag-qbksa-cai",
        "wxi2q-oiaaa-aaaaj-qab2q-cai",
        "wxrtj-paaaa-aaaal-qcb4a-cai",
        "wylwj-qqaaa-aaaak-qlrqq-cai",
        "wyv5o-tqaaa-aaaag-qbkta-cai",
        "wz42r-viaaa-aaaak-apacq-cai",
        "wzt6b-uqaaa-aaaal-qcb5a-cai",
        "x2oiq-waaaa-aaaag-qbbeq-cai",
        "x4oqm-bqaaa-aaaam-qahaq-cai",
        "x6avo-fqaaa-aaaah-qcuiq-cai",
        "x6mxl-caaaa-aaaag-qa4zq-cai",
        "x7pl6-siaaa-aaaag-qbnia-cai",
        "x7z74-uiaaa-aaaag-qbsnq-cai",
        "xaclh-iyaaa-aaaah-ad4oa-cai",
        "xak4p-3qaaa-aaaag-qbvsq-cai",
        "xarx3-ayaaa-aaaah-abjbq-cai",
        "xcep7-sqaaa-aaaah-qcukq-cai",
        "xcin2-vaaaa-aaaag-qa43q-cai",
        "xd2zm-2iaaa-aaaap-aawaa-cai",
        "xdlh5-iiaaa-aaaam-qa72a-cai",
        "xdzpj-yqaaa-aaaag-qjona-cai",
        "xe37i-hqaaa-aaaag-qc5aa-cai",
        "xe45w-fyaaa-aaaai-qkgfa-cai",
        "xe4dz-oqaaa-aaaag-qbspa-cai",
        "xehin-vyaaa-aaaah-abo4a-cai",
        "xeyge-6yaaa-aaaap-ahcba-cai",
        "xfjlo-yyaaa-aaaag-qa43a-cai",
        "xgket-maaaa-aaaam-qatwq-cai",
        "xh5oz-qiaaa-aaaag-qbkxq-cai",
        "xizxk-fqaaa-aaaap-aa2nq-cai",
        "xkbqi-2qaaa-aaaah-qbpqq-cai",
        "xkpgs-kaaaa-aaaap-aajea-cai",
        "xl2nu-iqaaa-aaaah-aq5ja-cai",
        "xoirh-aaaaa-aaaag-qbvtq-cai",
        "xpegl-kaaaa-aaaah-abcrq-cai",
        "xphpx-xyaaa-aaaah-qcmta-cai",
        "xpjz5-xiaaa-aaaag-qbbha-cai",
        "xrwnc-sqaaa-aaaah-abr2a-cai",
        "xumfy-nqaaa-aaaag-qbbfq-cai",
        "xv3za-4yaaa-aaaag-qbkuq-cai",
        "xwmac-eaaaa-aaaag-qbnjq-cai",
        "xxp4x-uiaaa-aaaag-qa4ya-cai",
        "xyjr3-wqaaa-aaaag-qcchq-cai",
        "xylfu-rqaaa-aaaag-qdhcq-cai",
        "xyonk-7qaaa-aaaag-qbniq-cai",
        "xyyzi-zqaaa-aaaag-qbsna-cai",
        "xz4z4-qyaaa-aaaap-abhta-cai",
        "xzcnc-myaaa-aaaak-abk7a-cai",
        "xzrh4-zyaaa-aaaaj-qagaa-cai",
        "xzxhy-oiaaa-aaaah-qclnq-cai",
        "y2ga5-lyaaa-aaaae-qae2q-cai",
        "y3b7h-siaaa-aaaah-qcnwa-cai",
        "y3st3-oyaaa-aaaah-aec2q-cai",
        "y47hk-qaaaa-aaaag-qcqia-cai",
        "y5ntm-piaaa-aaaag-qarta-cai",
        "y5phd-iiaaa-aaaag-qbuwa-cai",
        "y5prr-fiaaa-aaaam-qagga-cai",
        "y6okd-wqaaa-aaaag-qbmoq-cai",
        "ya4bk-oaaaa-aaaag-qb7fa-cai",
        "ya6vf-jaaaa-aaaag-qa2aa-cai",
        "ybd4y-raaaa-aaaae-qaeya-cai",
        "ybl5s-7iaaa-aaaag-qbuua-cai",
        "yc4eq-hqaaa-aaaag-qbtja-cai",
        "yckqs-bqaaa-aaaag-qbmmq-cai",
        "yd2q3-zyaaa-aaaag-qcisq-cai",
        "yd5mk-qyaaa-aaaag-qbh5q-cai",
        "ydyhv-2aaaa-aaaah-aq4oa-cai",
        "yek64-3aaaa-aaaag-qbyyq-cai",
        "yflau-biaaa-aaaam-qa64a-cai",
        "yflwg-miaaa-aaaag-qbmma-cai",
        "yfmkx-fiaaa-aaaag-qcdda-cai",
        "ygenm-saaaa-aaaah-qczaq-cai",
        "yhsek-pyaaa-aaaak-qiumq-cai",
        "yigae-jqaaa-aaaah-qczbq-cai",
        "yjp7w-nqaaa-aaaag-aaejq-cai",
        "yjr44-yyaaa-aaaah-qcsqq-cai",
        "yk22w-eaaaa-aaaal-qjlla-cai",
        "yk3mj-miaaa-aaaah-aq4pq-cai",
        "yl7pm-ryaaa-aaaag-qbtiq-cai",
        "ylxzc-gyaaa-aaaaj-qatra-cai",
        "ylyt5-yyaaa-aaaag-qc4hq-cai",
        "ym2d4-hyaaa-aaaag-qjpkq-cai",
        "yqkq3-tyaaa-aaaam-ab2xa-cai",
        "yqsfh-4aaaa-aaaaj-qattq-cai",
        "yr6qm-wqaaa-aaaah-aq4na-cai",
        "yrdz3-2yaaa-aaaah-qcvpa-cai",
        "ysmud-jqaaa-aaaam-qastq-cai",
        "yuenv-qiaaa-aaaae-qae3q-cai",
        "yv3qh-piaaa-aaaag-qb7gq-cai",
        "ywc7p-xaaaa-aaaah-qcvpq-cai",
        "yx3v5-gyaaa-aaaag-qbtkq-cai",
        "yxema-eqaaa-aaaak-afecq-cai",
        "yy7m6-daaaa-aaaag-qciqa-cai",
        "yyyg5-haaaa-aaaam-qavpa-cai",
        "yyyqp-kaaaa-aaaag-qbh7a-cai",
        "yzpmx-3iaaa-aaaag-qbmoa-cai",
        "yzrp5-oaaaa-aaaah-ad2xa-cai",
        "yzzyv-5iaaa-aaaag-qbtlq-cai",
        "z4v75-taaaa-aaaag-qbhza-cai",
        "z54wn-kaaaa-aaaae-qadbq-cai",
        "z5cvx-piaaa-aaaam-qa6ya-cai",
        "z5uxh-eiaaa-aaaag-qbtnq-cai",
        "z6lyl-lqaaa-aaaaj-qauja-cai",
        "z6vmv-xqaaa-aaaam-qazfa-cai",
        "z7mqv-liaaa-aaaah-qcnqa-cai",
        "z7rnh-2qaaa-aaaal-qdf6a-cai",
        "zarfm-eaaaa-aaaag-qbh3a-cai",
        "zdg5i-yqaaa-aaaai-acjda-cai",
        "zdvxw-nqaaa-aaaal-qdf4a-cai",
        "zdxun-dyaaa-aaaap-aa3ma-cai",
        "zejmq-rqaaa-aaaah-qcnsq-cai",
        "zgadr-rqaaa-aaaag-qcdfq-cai",
        "zghjs-vqaaa-aaaam-qa62q-cai",
        "zgt7n-zqaaa-aaaag-qawka-cai",
        "zhibq-piaaa-aaaah-qcvka-cai",
        "zi3qe-saaaa-aaaaj-qatxq-cai",
        "zi3rc-wiaaa-aaaah-ad2sq-cai",
        "zicoj-2aaaa-aaaap-aaiea-cai",
        "ziu23-maaaa-aaaag-qc4ba-cai",
        "zjsoq-siaaa-aaaag-qbh2q-cai",
        "zkw4k-3yaaa-aaaal-qdf5q-cai",
        "zle7i-5yaaa-aaaag-qbuta-cai",
        "zlkjc-5iaaa-aaaah-qczha-cai",
        "zmlpw-qqaaa-aaaah-qczhq-cai",
        "zndnx-oiaaa-aaaag-qcpia-cai",
        "znx26-waaaa-aaaal-qdf5a-cai",
        "zot6w-sqaaa-aaaam-qavka-cai",
        "zoxve-5aaaa-aaaal-qjlna-cai",
        "zp2wq-7yaaa-aaaaj-qatxa-cai",
        "zpaj4-miaaa-aaaal-qja4a-cai",
        "zpb4c-ayaaa-aaaag-qdgba-cai",
        "zqpvh-hqaaa-aaaah-qczfq-cai",
        "zthsm-ayaaa-aaaap-aaigq-cai",
        "zu7kv-faaaa-aaaaj-qatvq-cai",
        "zubiz-uaaaa-aaaag-qbmjq-cai",
        "zvycl-fyaaa-aaaah-qckmq-cai",
        "zydwz-laaaa-aaaam-qasuq-cai",
        "zyvuj-aaaaa-aaaag-qb7ba-cai",
        "zzk67-giaaa-aaaaj-qaujq-cai"
    ],
    "names": {
        "24ark-haaaa-aaaam-qazoa-cai": "Crypto Wizards",
        "26acc-dqaaa-aaaag-qbhsa-cai": "ICProvenance Robotex",
        "26snc-oqaaa-aaaai-qoxta-cai": "CreatorPlus",
        "27x62-syaaa-aaaag-qbmda-cai": "Memes",
        "2ceyt-uqaaa-aaaag-qbhqa-cai": "The Mask",
        "2dcmy-kyaaa-aaaag-qc4lq-cai": "FrensNWO",
        "2dtsz-iyaaa-aaaam-qa6ra-cai": "Healthliners",
        "2dwmv-lyaaa-aaaag-qdgla-cai": "Internet Doges",
        "2ftkf-7iaaa-aaaag-qbyva-cai": "ckBTC",
        "2gghi-aqaaa-aaaag-qa2na-cai": "ICPMONSTER PUNKS",
        "2glp2-eqaaa-aaaak-aajoa-cai": "CrowdFund NFT",
        "2iiif-4qaaa-aaaah-qcs5a-cai": "ICSpliffsters",
        "2l7rh-eiaaa-aaaah-qcvaa-cai": "ICVibesters",
        "2mgdj-caaaa-aaaam-qavba-cai": "Mecha Drip",
        "2mgv3-paaaa-aaaag-qbhra-cai": "Vermilion",
        "2n77z-oyaaa-aaaao-aakuq-cai": "Cool Bones",
        "2nelu-kqaaa-aaaag-qkaia-cai": "BoobsPunks",
        "2oyfj-oyaaa-aaaae-qaeuq-cai": "Hello World",
        "2rarf-5qaaa-aaaag-qkaka-cai": "Crypto 80s",
        "2remf-7aaaa-aaaal-qcm5a-cai": "NakaMotos",
        "2rvts-jiaaa-aaaag-qbmca-cai": "DRGN",
        "2s2iy-xaaaa-aaaah-qczoq-cai": "Drakon NFT",
        "2tvxo-eqaaa-aaaai-acjla-cai": "IC Dream Whale",
        "2v5zm-uaaaa-aaaae-qaewa-cai": "Clown Skateboards",
        "2vd2w-riaaa-aaaam-qazpq-cai": "⭐CoinStarsNFT",
        "2wucc-5yaaa-aaaal-qb4xa-cai": "cryptotext",
        "2x3lw-tiaaa-aaaah-qcvca-cai": "DfinityGangs",
        "2xv54-tyaaa-aaaag-qbywa-cai": "Gothic Skull",
        "2zw3f-pqaaa-aaaaf-qakaa-cai": "Nuance: xVALORIAN",
        "2zxqu-iiaaa-aaaag-qbyxa-cai": "akane collection",
        "323zs-4qaaa-aaaag-qbyrq-cai": "The Zombie",
        "33mfk-nyaaa-aaaag-qbtaq-cai": "WE WRESTLE CHAMP",
        "343x4-gaaaa-aaaag-qbmfq-cai": "ICPlat 2.0",
        "3a737-4aaaa-aaaam-qa6xq-cai": "LuMari III: Robotix",
        "3bpne-jiaaa-aaaag-qcizq-cai": "RAWKATS.. everywhere",
        "3bqt5-gyaaa-aaaah-qcvha-cai": "ICP.DOG",
        "3cjkh-tqaaa-aaaam-qan6a-cai": "KVHS Drafts",
        "3db6u-aiaaa-aaaah-qbjbq-cai": "Wrapped IC Drip",
        "3e7gz-caaaa-aaaag-qbu7q-cai": "ICPlanets",
        "3h2b5-haaaa-aaaag-qjqfq-cai": "Earth's Golden Age",
        "3h6lz-4yaaa-aaaag-qbmha-cai": "MyMonkeys",
        "3ifmd-wqaaa-aaaah-qckda-cai": "ICSnakes",
        "3ilm3-3aaaa-aaaam-qavha-cai": "Maths Art Collection",
        "3j4qd-kiaaa-aaaam-qa6wa-cai": "Memory Quilt Pieces",
        "3kt53-zaaaa-aaaah-qczkq-cai": "Crypto 90s",
        "3l372-hyaaa-aaaag-qcpfa-cai": "SOJY",
        "3mttv-dqaaa-aaaah-qcn6q-cai": "Dfinity Space Apes",
        "3n4nf-uiaaa-aaaag-qbu6a-cai": "DSA Planets",
        "3rove-iiaaa-aaaam-qazjq-cai": "MiMons",
        "3toq6-byaaa-aaaam-qavfq-cai": "IC WINES CLUB",
        "3tyso-kyaaa-aaaag-qbyqa-cai": "Dream Zodiac",
        "3ul5y-dqaaa-aaaal-qjlca-cai": "Nexus XXIII",
        "3vdxu-laaaa-aaaah-abqxa-cai": "Cubetopia Islands",
        "3voic-wiaaa-aaaag-qbtbq-cai": "ICP Ecosystem Banner",
        "3vy4a-qiaaa-aaaag-qbmea-cai": "Adorable Assistant",
        "42fn2-wyaaa-aaaak-aafwq-cai": "Dmail Network",
        "437zq-dqaaa-aaaag-qa5eq-cai": "EXTRATERRESTRIAL",
        "43sol-iqaaa-aaaak-qitiq-cai": "San Andreas Apes",
        "46sy3-aiaaa-aaaah-qczza-cai": "IC PXY",
        "4bpnc-paaaa-aaaag-qbtsa-cai": "ARMADURA",
        "4dz42-aqaaa-aaaag-qba3q-cai": "RetroPunk",
        "4fcza-biaaa-aaaah-abi4q-cai": "Finny EA Card",
        "4fxe6-2qaaa-aaaah-qcz3q-cai": "ICGiraffes",
        "4fzsu-2aaaa-aaaag-qbupq-cai": "Expressionism",
        "4gbxl-byaaa-aaaak-aafuq-cai": "ICPuppies Wearables",
        "4ggk4-mqaaa-aaaae-qad6q-cai": "ICP Flower",
        "4gyjg-jyaaa-aaaam-qa6ha-cai": "CLOUDS",
        "4hzxo-tqaaa-aaaag-qbydq-cai": "material skull",
        "4j32g-iaaaa-aaaag-qbycq-cai": "Galaxy Girls",
        "4k2xg-wyaaa-aaaag-qba2a-cai": "Steampunk Bullrun 2",
        "4k65c-naaaa-aaaag-qj4yq-cai": "Angry Motoko Birds",
        "4kubm-wiaaa-aaaah-qcnoa-cai": "TheSwordNFT - Ninjas",
        "4lnl6-hqaaa-aaaag-qblla-cai": "ICPSwap MOR Position(LP) NFT",
        "4m2zi-miaaa-aaaag-qbuoa-cai": "D-Robot",
        "4mm3y-hiaaa-aaaam-qaz3q-cai": "Astro Samurai",
        "4mupc-myaaa-aaaah-qcz2a-cai": "IC Birds",
        "4nvhy-3qaaa-aaaah-qcnoq-cai": "ICats",
        "4odun-ayaaa-aaaak-aarbq-cai": "Sa-Chan",
        "4ojdp-jaaaa-aaaah-aq4ua-cai": "The Future of the Arts",
        "4p76m-jiaaa-aaaag-qjqua-cai": "Only 12",
        "4pnak-uqaaa-aaaag-qbtta-cai": "STEAMON",
        "4q4as-faaaa-aaaal-qab4q-cai": "Artific",
        "4q6dz-3iaaa-aaaag-qbuma-cai": "DECEPTION.GIF",
        "4qmvs-qyaaa-aaaal-ab2rq-cai": "Plethora Items",
        "4s6gd-syaaa-aaaag-qbyaa-cai": "Ice cream",
        "4smyf-paaaa-aaaag-qj3ha-cai": "Corporate Cats",
        "4tb3r-nyaaa-aaaae-qad5a-cai": "FPDAOxIRO",
        "4tj23-dqaaa-aaaag-qbtra-cai": "CUP OF JOE",
        "4vy4g-waaaa-aaaag-qcxpq-cai": "Unchained & Friends",
        "4wiph-kyaaa-aaaam-qannq-cai": "Martian Drip",
        "4z5if-naaaa-aaaag-qbunq-cai": "CHIBI",
        "4zv6l-2aaaa-aaaaj-qauua-cai": "The Emperor",
        "527xj-ziaaa-aaaah-qcz7a-cai": "Revolució",
        "52hdt-syaaa-aaaam-qaz6q-cai": "IC Precious",
        "54vfj-yqaaa-aaaag-qj45q-cai": "ICP Renegades Music",
        "556r5-uqaaa-aaaah-qcz7q-cai": "Dfinity Dragonz",
        "55qhx-uaaaa-aaaag-qbulq-cai": "COMIC",
        "5gv3s-oyaaa-aaaag-qbuja-cai": "Spy x Family",
        "5h2fc-zaaaa-aaaah-qcnjq-cai": "ICPrime8s",
        "5i7j7-qiaaa-aaaak-qlqoa-cai": "Innovation 5.0",
        "5izaq-vyaaa-aaaah-qcz4a-cai": "Dfinity Rats",
        "5jw6a-caaaa-aaaag-qba4q-cai": "Reboot",
        "5kxta-4yaaa-aaaag-qbyea-cai": "Kingdom of the Apes",
        "5lapy-nqaaa-aaaag-qbtva-cai": "DIVINITY",
        "5lwni-gqaaa-aaaam-qa6aq-cai": "COLDEST",
        "5movr-diaaa-aaaak-aaftq-cai": "ICPuppies",
        "5nrjf-yaaaa-aaaag-qcxlq-cai": "ALP",
        "5otsq-uaaaa-aaaag-qj46q-cai": "GOATs of UNIX",
        "5paem-6qaaa-aaaag-qblna-cai": "Pixel City Series",
        "5pyge-yaaaa-aaaah-qcz4q-cai": "ICNotes",
        "5qtrn-4iaaa-aaaam-qa6ca-cai": "EVERYDAY",
        "5rspf-gaaaa-aaaag-qbygq-cai": "OOPARTS",
        "5stux-vyaaa-aaaam-qasoa-cai": "Nuclear Radio",
        "5t24r-yqaaa-aaaaj-qauta-cai": "The Empress",
        "5t44v-paaaa-aaaah-qcz6q-cai": "ETH BUTTERFLY NFT",
        "5wr56-myaaa-aaaag-qa5da-cai": "ICMallows World Cup",
        "5wtjr-lyaaa-aaaag-qbyga-cai": "ANUBIS",
        "64sdk-4iaaa-aaaag-qbt5q-cai": "LUNAVERSE",
        "64x4q-laaaa-aaaal-qdjca-cai": "Cellphones",
        "65f7s-naaaa-aaaag-qbymq-cai": "SPACEMAN",
        "65hl5-kaaaa-aaaag-qa5jq-cai": "IC VERSE",
        "6bbfd-2aaaa-aaaag-qbyoq-cai": "end of space",
        "6bxrb-4aaaa-aaaag-qbhla-cai": "𝐓𝐇𝐄 𝐌𝐘𝐓𝐇",
        "6e6eb-piaaa-aaaaj-qal6a-cai": "Chaos Tarot Decks",
        "6eagn-6iaaa-aaaag-qbuca-cai": "Spaceship: 1977",
        "6eaq7-tiaaa-aaaam-qagsa-cai": "DfinityPigs",
        "6eh24-xiaaa-aaaag-qc3na-cai": "ckBINGO",
        "6fosk-kaaaa-aaaak-aawqq-cai": "Kinic (Crowdfund)",
        "6gcxy-qyaaa-aaaag-qa5la-cai": "NEGA PIC",
        "6hgw2-nyaaa-aaaai-abkqq-cai": "Cipher",
        "6imyv-myaaa-aaaah-qcv3a-cai": "Feminiverse",
        "6jvsh-5aaaa-aaaag-qbt6a-cai": "Pocket Monsters",
        "6kdwg-paaaa-aaaap-qbuea-cai": "ToyoWorld Founders Passes",
        "6kk5l-syaaa-aaaaj-qau2q-cai": "The Hierophant",
        "6km5p-fiaaa-aaaah-qczxa-cai": "IKUZO",
        "6olkk-7iaaa-aaaah-qboaa-cai": "ICPBunny (Testnet)",
        "6pv4j-hqaaa-aaaag-qbhka-cai": "SNS-1 Logo Drop",
        "6qlam-vaaaa-aaaah-abddq-cai": "ARES Cars",
        "6rw7t-qaaaa-aaaag-qcela-cai": "IC Penguins",
        "6sqoc-hyaaa-aaaag-qbt4q-cai": "Mechazord",
        "6tjeq-waaaa-aaaah-qcvzq-cai": "IC8 🐣",
        "6tw2j-zqaaa-aaaag-qciha-cai": "PIXAVATAR",
        "6uguo-3iaaa-aaaag-qbyna-cai": "PHILOSOPHER",
        "6ujx2-xiaaa-aaaak-qitea-cai": "3 Monkeee Problem",
        "6wghg-7yaaa-aaaam-qagra-cai": "IC Baboons",
        "6wgru-syaaa-aaaag-qbuba-cai": "Bone Soup",
        "6wih6-siaaa-aaaah-qczva-cai": "IC BUCKS",
        "6wqte-zyaaa-aaaam-qazuq-cai": "3DCC",
        "7324y-zaaaa-aaaal-qjhua-cai": "Funtokos",
        "736xk-wqaaa-aaaam-qazta-cai": "STRUCTURE",
        "73xld-saaaa-aaaah-qbjya-cai": "Wing",
        "74jto-qiaaa-aaaag-qbuga-cai": "Rub's",
        "76jwu-zyaaa-aaaag-qbyka-cai": "Bitcoin Lion",
        "776km-iqaaa-aaaag-qbt3a-cai": "RIKO",
        "77bch-kaaaa-aaaan-qa4vq-cai": "GHOST Community Badge NFT",
        "7a355-biaaa-aaaag-qblbq-cai": "ICP Color Guys",
        "7anj7-hiaaa-aaaag-qbuea-cai": "CYBER OUTSIDERS",
        "7cpyk-jyaaa-aaaag-qa5na-cai": "BOX ON BLOCK",
        "7eavq-7iaaa-aaaak-qjcqa-cai": "4 MORE PROBLEMS",
        "7fdjf-paaaa-aaaak-qitbq-cai": "DFINITY Maxi Biz",
        "7gayh-aqaaa-aaaah-abdgq-cai": "8YearGang Genesis Collection",
        "7gipp-tyaaa-aaaag-qdk2a-cai": "ICPretty Fish",
        "7gvfz-3iaaa-aaaah-qcsbq-cai": "Digms",
        "7hmpl-kqaaa-aaaag-qbueq-cai": "CONTINUES",
        "7i54s-nyaaa-aaaal-abomq-cai": "DfinityDeck:ORIGINS",
        "7lyt3-6qaaa-aaaag-qbhma-cai": "Argentine Emperor",
        "7mi54-4iaaa-aaaag-qcxga-cai": "ckORDI",
        "7n5cp-tiaaa-aaaal-qdjhq-cai": "Mutant Alien Bots",
        "7no7f-paaaa-aaaam-qa6nq-cai": "Daynerds",
        "7qjpt-fiaaa-aaaag-qa5oa-cai": "Cosmo-Angel",
        "7qno3-maaaa-aaaak-qt5pq-cai": "PsiCats",
        "7rktg-vaaaa-aaaag-qbm7q-cai": "Lazy Crypto Guys",
        "7rozc-oyaaa-aaaag-qjq5a-cai": "Blockchain Enlightenment.",
        "7sfim-liaaa-aaaah-qczta-cai": "Nuclear Sheep",
        "7ush6-3iaaa-aaaak-qiu7q-cai": "SPACE ODYSSEY",
        "7vkys-gaaaa-aaaag-qbuhq-cai": "MAN CAVES",
        "7wlda-vyaaa-aaaam-qa6pa-cai": "Echizen Skull TB",
        "7x4jk-jqaaa-aaaag-qbhoa-cai": "D10S",
        "7yoel-kiaaa-aaaag-qcdra-cai": "The Royal Knights",
        "a2g7g-ayaaa-aaaag-qbwna-cai": "Ballerina Rhapsody",
        "a2qle-gyaaa-aaaag-qbjiq-cai": "Dfinity Banana",
        "a6gca-6yaaa-aaaam-qa4fa-cai": "Pattern Surface NFT",
        "a7aaz-nqaaa-aaaag-qcvoq-cai": "ToyoWorldxPokedbots",
        "a7h4i-eqaaa-aaaag-qb2bq-cai": "VCC - TAB#01",
        "aahdh-diaaa-aaaag-qdira-cai": "Nakamantes",
        "acu2b-cyaaa-aaaag-qbrsq-cai": "KeyBlade",
        "afdix-jaaaa-aaaag-qboxq-cai": "Renaissance Dogs",
        "afeug-aaaaa-aaaag-qcbyq-cai": "Cthulhu - Pets",
        "afeuw-qaaaa-aaaap-aakya-cai": "Revelation Walls",
        "aguhh-4yaaa-aaaam-qa32q-cai": "Tyrant Turtles",
        "ahl3d-xqaaa-aaaaj-qacca-cai": "ICTuTs",
        "ahos3-5yaaa-aaaah-abbna-cai": "ICFlowers (Airdrop)",
        "aiai7-miaaa-aaaag-qbwoa-cai": "Phenomenological",
        "aitud-eiaaa-aaaag-qddbq-cai": "IC∞ COFFEE STAMPS",
        "aiw45-kiaaa-aaaag-qbjlq-cai": "El Patrón Medellín",
        "akczk-cyaaa-aaaag-qa7ha-cai": "Steampunk Bullrun",
        "albtn-7qaaa-aaaam-qa4gq-cai": "Duo ICells",
        "algzo-3qaaa-aaaag-qcbzq-cai": "Soul Bound Spark",
        "arttq-uaaaa-aaaam-qaxva-cai": "Life in the Cosmos",
        "aseks-myaaa-aaaam-qaqia-cai": "Studly Dozen",
        "attwk-5qaaa-aaaam-qa3za-cai": "HELLION",
        "aueso-3iaaa-aaaag-qbwma-cai": "BearHeads",
        "auggb-4iaaa-aaaag-qatja-cai": "BABY AROF",
        "ausgm-5iaaa-aaaag-qbjjq-cai": "New Year Mario",
        "awbbf-xqaaa-aaaai-qieaa-cai": "ICPugs",
        "axcd7-mqaaa-aaaag-qcb3q-cai": "ICPixmain",
        "axwuw-uyaaa-aaaal-qdloq-cai": "Zombie Trader",
        "azdpg-4qaaa-aaaal-qjccq-cai": "Modernist x BitBasel Moonrider Collection",
        "azsqr-kyaaa-aaaag-qkc5q-cai": "FOXINITY",
        "b547e-maaaa-aaaam-qadga-cai": "Snowmen MVP",
        "b5el6-hqaaa-aaaah-qcdhq-cai": "Wild and West",
        "b6lqu-zyaaa-aaaag-qbwla-cai": "CLUB SINGULARITY",
        "bapzn-kiaaa-aaaam-qaiva-cai": "ICLands",
        "bbyth-waaaa-aaaag-qbrua-cai": "Nemesis Series Vol.1",
        "bcz6h-iyaaa-aaaag-qbjmq-cai": "Adopt Me Please!",
        "bepel-uiaaa-aaaag-qbc5a-cai": "Epic NFT Club",
        "bfyob-iaaaa-aaaam-qa34a-cai": "Colorful Abstracts",
        "bgnv6-2yaaa-aaaag-qalua-cai": "Artwork for NFTs",
        "bi3y3-aiaaa-aaaag-qbrvq-cai": "Gothic Girl",
        "bid2t-gyaaa-aaaah-qcdea-cai": "Haunted Hamsters",
        "bjcsj-rqaaa-aaaah-qcxqq-cai": "Avocado Research",
        "bk5uo-miaaa-aaaal-qiulq-cai": "Motoko Sentinels",
        "bkvll-jiaaa-aaaah-qcqnq-cai": "2D Assassins!!!",
        "bm3f5-6iaaa-aaaam-qa35q-cai": "Orblings Emblem",
        "bm3tp-tiaaa-aaaag-qbjnq-cai": "D.O.G",
        "bmk34-4iaaa-aaaag-qczha-cai": "EGG",
        "bp26p-nqaaa-aaaag-qbrva-cai": "Smoking Kills",
        "brx5n-xqaaa-aaaan-qanqa-cai": "ICPSwap MOR Position(LP) NFT",
        "bsdmf-gyaaa-aaaak-acgka-cai": "iUSD",
        "btggw-4aaaa-aaaah-qcdgq-cai": "IC Pumpkins",
        "btiq4-4qaaa-aaaag-qbosq-cai": "PSYCHEDELIC ∞",
        "buja2-4iaaa-aaaam-qa4ca-cai": "iistronauts",
        "bvckr-laaaa-aaaak-acgkq-cai": "Cubetopia Founder’s Pass",
        "bx6pk-jqaaa-aaaag-qbjpa-cai": "CUBEBOT",
        "bxdf4-baaaa-aaaah-qaruq-cai": "Wrapped ICPunks",
        "bxsmj-kiaaa-aaaaj-aai3a-cai": "HS testers",
        "byowe-niaaa-aaaag-qdiva-cai": "Legend of Zeldoge",
        "bzsui-sqaaa-aaaah-qce2a-cai": "Poked Bots",
        "c77wz-2qaaa-aaaam-qa4iq-cai": "MartianVHS",
        "ca4b4-uyaaa-aaaal-aac7a-cai": "C4Meadow",
        "caij4-dqaaa-aaaag-qjvfa-cai": "Personal DAO OG Pass",
        "cchps-gaaaa-aaaak-qasaa-cai": "Boxy Girl",
        "cdvmq-aaaaa-aaaah-qcdoq-cai": "Selay Karasu",
        "ce2k4-aiaaa-aaaam-qa4ka-cai": "PAW Collection",
        "ce6wk-wqaaa-aaaag-qjsyq-cai": "Wen CoinGecko",
        "chnfm-vqaaa-aaaag-qbjha-cai": "IC Elephants",
        "cib4d-2iaaa-aaaak-aaluq-cai": "KontributeNFT (CrowdFundNFT)",
        "cihkf-qyaaa-aaaah-qb7jq-cai": "ICMojis Items",
        "ck7nx-7yaaa-aaaag-qcbua-cai": "Pepexl.hehe",
        "ckbgq-4yaaa-aaaak-qi2xq-cai": "Wumbros",
        "ckiml-viaaa-aaaal-qiymq-cai": "Dooza's",
        "ckwhm-wiaaa-aaaah-qcdpa-cai": "PatternBased",
        "ckyrg-wyaaa-aaaag-qbo3a-cai": "BABY A.I",
        "cl6fn-iqaaa-aaaag-qcvaq-cai": "ICPxDEMO Certificate",
        "cm2lh-liaaa-aaaag-qa7ka-cai": "IC-P Bot24",
        "cn47m-vaaaa-aaaag-qderq-cai": "8YG",
        "cnxby-3qaaa-aaaah-qcdpq-cai": "Andre Wee",
        "cokeu-yaaaa-aaaag-qjvea-cai": "DAS - Scott Bateman",
        "cppgk-uqaaa-aaaag-qb5sa-cai": "Lion Warriors",
        "crt3j-mqaaa-aaaah-qcdnq-cai": "Neil White",
        "ctt6t-faaaa-aaaah-qcpbq-cai": "Infernal Vampire Colony Gen2",
        "cuioa-jiaaa-aaaag-qayvq-cai": "Street Vernacular",
        "cvlsv-zaaaa-aaaag-qbjea-cai": "ICPDIAMOND BADGE",
        "cw4lx-byaaa-aaaag-qboza-cai": "ISOMETRIC ISLAND",
        "cwu5z-wyaaa-aaaaj-qaoaq-cai": "Saga Legends #1: The Magician",
        "cwzdj-pyaaa-aaaag-qdeta-cai": "Sloths Eating Pizza",
        "cx7xc-rqaaa-aaaag-qa7iq-cai": "Coal & Paper",
        "cxlb5-5qaaa-aaaam-qaxya-cai": "WAGMI Dystopian Club",
        "cy2m3-bqaaa-aaaag-qjs2q-cai": "Trump With Hat",
        "czogw-caaaa-aaaag-qckga-cai": "The Eye of NDF",
        "d3ttm-qaaaa-aaaai-qam4a-cai": "IC Drip",
        "dahor-xyaaa-aaaal-qiylq-cai": "Motoko Doodles",
        "davht-tiaaa-aaaag-qalza-cai": "ICP Swap Co-Founder Creation - Animated X",
        "dcbuw-wyaaa-aaaam-qapfq-cai": "Genesis Hats",
        "deb2y-miaaa-aaaam-qa3rq-cai": "Crown Membership",
        "dfcq7-raaaa-aaaag-qayqa-cai": "Cursed Bijin",
        "dhiaa-ryaaa-aaaae-qabva-cai": "ETH Flower",
        "dhyds-jaaaa-aaaao-aaiia-cai": "Obsidian Tears",
        "djuya-caaaa-aaaag-qbo5q-cai": "Ogre King",
        "dkdbc-2yaaa-aaaag-qbjaq-cai": "Winter Fairytale",
        "dknxi-2iaaa-aaaah-qceuq-cai": "Dfinity Bulls",
        "dkt4p-ziaaa-aaaal-qi7xa-cai": "Motoko Stickies",
        "dsamw-xyaaa-aaaag-qc6vq-cai": "Windoge Explorer",
        "dsref-yyaaa-aaaag-qbo7a-cai": "SKULLDELIC ∞",
        "dtlqp-nqaaa-aaaak-abwna-cai": "IC Apps",
        "duh6j-eiaaa-aaaag-qbfoq-cai": "𝐒𝐇𝐈𝐍𝐈𝐆𝐀𝐌𝐈",
        "dur4z-piaaa-aaaam-qai3a-cai": "ICode DAO NFT pass",
        "dv6u3-vqaaa-aaaah-qcdlq-cai": "Tyler Monsein & Dakota Light-Smith",
        "dxehg-5qaaa-aaaag-qayta-cai": "Crypto Blocks ∞",
        "dylar-wyaaa-aaaah-qcexq-cai": "Flight",
        "e2ung-3qaaa-aaaam-qa46q-cai": "A-Crystal",
        "e3izy-jiaaa-aaaah-qacbq-cai": "Cronic Critters",
        "e4ca6-oiaaa-aaaai-acm2a-cai": "3D Dream Whale",
        "e5djc-5iaaa-aaaag-qbrlq-cai": "ICPAA: Empty Frames",
        "e6uqa-fqaaa-aaaag-qbwwq-cai": "Xrown👑",
        "e7xmv-vyaaa-aaaag-qahha-cai": "ValentinesDay Exclusive NFT",
        "eagn3-qaaaa-aaaam-qaxna-cai": "ISWL",
        "eb7r3-myaaa-aaaah-qcdya-cai": "Iconic2021",
        "ebtt6-liaaa-aaaag-qalja-cai": "ICP Swap Founders Edition",
        "ecqkr-sqaaa-aaaag-qbwuq-cai": "IC Old Shoes",
        "edhwj-dyaaa-aaaag-qb5fq-cai": "ICFriends",
        "eejma-naaaa-aaaak-aalda-cai": "Cosmicrafts (CrowdFundNFT)",
        "efaew-qiaaa-aaaag-qcg6q-cai": "Road Trip",
        "efbpx-hqaaa-aaaam-ab7ja-cai": "Rune Specific Internet Canisters (RSIC)",
        "egsvk-gqaaa-aaaag-qaljq-cai": "The road of art",
        "ehr7n-3yaaa-aaaam-qaiia-cai": "CLUB CANI",
        "ems7u-lyaaa-aaaal-qnbma-cai": "Motoko Monsters Gen 2",
        "enae3-paaaa-aaaal-qdh3a-cai": "GN Punks Ordinals",
        "eosur-nqaaa-aaaam-qaijq-cai": "Terence's Art Sale",
        "ep54t-xiaaa-aaaah-qcdza-cai": "ICPuppies Wearables",
        "eptkz-xyaaa-aaaag-qbona-cai": "Flat ICY PEE",
        "epxa5-maaaa-aaaag-qjspq-cai": "Puuupy",
        "er7d4-6iaaa-aaaaj-qac2q-cai": "The Moonwalkers",
        "erfen-7aaaa-aaaap-ahniq-cai": "Daku Motoko",
        "erpx2-pyaaa-aaaah-qcqsq-cai": "Voxel Assassins!!!",
        "etbek-gyaaa-aaaag-qbrkq-cai": "Outcast",
        "ey3ct-4aaaa-aaaak-aaueq-cai": "ICPSwap 1.0 Memorial NFT",
        "f5ybl-tqaaa-aaaal-qnbjq-cai": "Microbo",
        "f5yzg-riaaa-aaaag-qbwqa-cai": "SCROLLS - BLOCKCHAIN",
        "fc5ox-yqaaa-aaaag-qbokq-cai": "Mini Figure",
        "fc5yf-vqaaa-aaaam-qa42q-cai": "Goated Gamer DAO",
        "fg5fd-lqaaa-aaaag-qbwsq-cai": "Mushroom Poison",
        "fi7il-qaaaa-aaaag-qbwtq-cai": "CULT.GIF",
        "fjhio-ciaaa-aaaak-aaleq-cai": "IC Ukraine Support (CrowdFundNFT)",
        "fkntx-eiaaa-aaaag-qjzyq-cai": "majestic steaks",
        "fl5nr-xiaaa-aaaai-qbjmq-cai": "ICTurtles",
        "fojcx-iaaaa-aaaap-qhmbq-cai": "SoZo Profiles",
        "fooog-vqaaa-aaaap-aaznq-cai": "Trax",
        "fpimp-wyaaa-aaaam-qa3gq-cai": "Cosmic Tacos",
        "fryf3-eiaaa-aaaag-qa7ya-cai": "P&P",
        "fx272-zyaaa-aaaag-qboja-cai": "MetaLeo Genesis",
        "fx5d3-ayaaa-aaaap-aakgq-cai": "TPUNKS",
        "fx6v6-caaaa-aaaag-qjslq-cai": "Blockchain Genie",
        "fzogq-eiaaa-aaaag-qbrnq-cai": "isaythanks",
        "g3yn2-gaaaa-aaaag-qkcla-cai": "BADGUY",
        "g4253-zaaaa-aaaag-qbrga-cai": "B.K",
        "g4o5w-yaaaa-aaaag-qalgq-cai": "Pure Innocence",
        "g53vb-oiaaa-aaaag-qbfsq-cai": "Flat People",
        "g5pvm-piaaa-aaaag-qa7sa-cai": "PixelPosters",
        "g73gj-kyaaa-aaaam-qa3oq-cai": "BIOMORPH",
        "gaiti-iaaaa-aaaag-qbobq-cai": "IC Dreamscapes",
        "ge4yr-2aaaa-aaaag-qamza-cai": "ICP.Dog Badge NFT Collection",
        "gevsk-tqaaa-aaaah-qaoca-cai": "ICmojis",
        "gfcya-pyaaa-aaaan-qbxda-cai": "SNS&GHOST NFT",
        "gfjqg-miaaa-aaaag-qbcna-cai": "G.O.A.T",
        "gfmyy-ciaaa-aaaag-qdiha-cai": "A.I. Movie Posters",
        "gh7b6-dyaaa-aaaag-qbreq-cai": "1940 Combat",
        "ghjdo-iyaaa-aaaam-qa4ra-cai": "Abikes",
        "ghqck-pyaaa-aaaak-qi2nq-cai": "DFINITY MAXIBIZ CARD",
        "ghxmp-xiaaa-aaaao-ba4sq-cai": "IC SPICY / PepperHeads",
        "gi4em-paaaa-aaaag-qbfra-cai": "Satoshi's Ghost",
        "gikg4-eaaaa-aaaam-qaieq-cai": "Mutant Space Apes",
        "gikqo-jaaaa-aaaag-qb2uq-cai": "Earthquake Charity",
        "gj2qh-riaaa-aaaag-qc6kq-cai": "Crypto Wizards v2 B",
        "gjlyu-6iaaa-aaaag-qboaa-cai": "Trapped Skulls",
        "gk4xe-lqaaa-aaaam-qa3na-cai": "MechaFailed",
        "gksxm-waaaa-aaaao-aapjq-cai": "Catalyze",
        "gl5jm-ryaaa-aaaag-qb5jq-cai": "ICPhantoms",
        "gll5o-xyaaa-aaaag-qbcma-cai": "MonkeeeParade",
        "gm4py-4aaaa-aaaag-qb5ja-cai": "Ghost Kid",
        "gn5hc-liaaa-aaaag-qbj5q-cai": "VMALE",
        "goei2-daaaa-aaaao-aaiua-cai": "Obsidian Tears Items and Artifacts",
        "goikp-uqaaa-aaaag-qalfq-cai": "ICGAL",
        "gpjcv-dyaaa-aaaag-qa7ra-cai": "CryptoNinjas Avatars",
        "gq5kt-4iaaa-aaaal-qdhuq-cai": "Partyhats",
        "gsyqt-cqaaa-aaaag-qbrha-cai": "Farmhouse Pixel",
        "gtb2b-tiaaa-aaaah-qcxca-cai": "D-City",
        "guy65-yaaaa-aaaag-qbfta-cai": "High Rise Building",
        "gyuaf-kqaaa-aaaah-qceka-cai": "Infernal Vampire Colony",
        "gz2dw-xqaaa-aaaap-qb5nq-cai": "ckHEDGE",
        "gzn5t-caaaa-aaaal-qbs2q-cai": "Blockchain Love",
        "h3all-yyaaa-aaaag-qbw5a-cai": "Infinity Sea",
        "h4gro-4aaaa-aaaag-qczsq-cai": "GoodGuy",
        "h7aa7-lyaaa-aaaag-qbofa-cai": "BTC Vase",
        "hafxo-caaaa-aaaag-qbw7q-cai": "ABC Verse",
        "hbe7u-viaaa-aaaag-qbcla-cai": "Game of Thrones",
        "hctgw-nqaaa-aaaag-qbfwa-cai": "Space Monkeys",
        "hdxhu-qqaaa-aaaai-aasnq-cai": "Candy Library",
        "hfswq-niaaa-aaaam-qaxgq-cai": "Champs Creed",
        "hhce5-bqaaa-aaaak-qtt3q-cai": "Motoko-Pals",
        "hhsfy-jyaaa-aaaag-qbj2q-cai": "BULLISH",
        "hhwp4-saaaa-aaaag-qjvya-cai": "Double Avatar",
        "hihui-daaaa-aaaag-qbckq-cai": "Monkey Infinity",
        "hirak-faaaa-aaaag-qb5pa-cai": "Crypto Wizards V2",
        "hjg4s-uiaaa-aaaag-qbw6a-cai": "PLEASURE",
        "hjq6c-7iaaa-aaaam-qa3lq-cai": "Astro Samurai -Anime",
        "hjqiq-siaaa-aaaag-qbj3q-cai": "Koi Tokugawa",
        "hjuvq-qyaaa-aaaal-qjfmq-cai": "BTC Flower Gen 2.1",
        "hkff5-nqaaa-aaaag-qaldq-cai": "luoyingbinfen",
        "hmvb2-nyaaa-aaaag-qjzvq-cai": "MOTOKO ALIENS",
        "hnedj-aiaaa-aaaag-qalda-cai": "Japan scenery",
        "hoh2g-zqaaa-aaaag-qbw6q-cai": "IC Rock",
        "hovea-eiaaa-aaaag-qjvzq-cai": "iistronauts Gen 2.0",
        "hqvh5-maaaa-aaaam-qaxfa-cai": "IC Calida",
        "hqvrp-baaaa-aaaag-qbfva-cai": "Keys",
        "hvgd6-taaaa-aaaap-ahgsa-cai": "Pixel Girls",
        "hvusb-fiaaa-aaaag-qbjzq-cai": "Movie Actors",
        "hxaxw-nyaaa-aaaag-qa7va-cai": "R.O.B.O.T",
        "hybqz-laaaa-aaaam-qa4vq-cai": "Li◭gt",
        "hzc26-wiaaa-aaaag-qa7ua-cai": "Goddesses",
        "hzw2t-xiaaa-aaaag-qbfuq-cai": "Hypercube",
        "i2xig-xaaaa-aaaam-qa2oa-cai": "Boys On IC",
        "i5a2q-4yaaa-aaaam-qafla-cai": "Internet Creeps",
        "i5gfn-uiaaa-aaaal-qi6ja-cai": "Motoko Monsters",
        "i6bbc-paaaa-aaaag-qbpdq-cai": "BTC BORN",
        "ibewt-gyaaa-aaaag-qbxza-cai": "Nature Of Cranium",
        "iih5p-qqaaa-aaaag-qbxyq-cai": "Dominic Overdrive",
        "iiibs-tqaaa-aaaak-aab6q-cai": "Imagine",
        "ilc2l-vqaaa-aaaag-qjtcq-cai": "PIXELATED Abstracts",
        "ilqen-iiaaa-aaaag-qbqfq-cai": "Monkeys Land",
        "imhw3-dqaaa-aaaag-qbpaq-cai": "Mister Funk",
        "iohft-haaaa-aaaam-qar4q-cai": "LIVING ABETZ",
        "ipchn-lqaaa-aaaam-qizkq-cai": "Corporate Cloud Consortium",
        "iqvyi-sqaaa-aaaag-qbqha-cai": "3D ROOMS",
        "ircsc-oyaaa-aaaam-qajga-cai": "Galactic Guardians",
        "issbt-caaaa-aaaap-aayeq-cai": "ModClub",
        "itud2-biaaa-aaaam-qa2pq-cai": "Cosmo-Gem",
        "iudh6-hqaaa-aaaag-qbx2q-cai": "Internet Brain",
        "iurzy-2iaaa-aaaag-qju5q-cai": "Bitcoin Astronauts",
        "ivgzt-yyaaa-aaaau-agwma-cai": "The Systematic Defense of Agentic Architectures",
        "ixck6-ziaaa-aaaag-qbpca-cai": "DEVOUR",
        "iyzne-taaaa-aaaah-qcjga-cai": "Crazy Zombie",
        "j3c2x-ciaaa-aaaak-aanxa-cai": "Music Video NFT (CrowdFundNFT)",
        "j3dqa-byaaa-aaaah-qcwfa-cai": "ICPCS",
        "j663c-yyaaa-aaaag-qju2q-cai": "Crypto Circus Ticktz",
        "j7n3m-7iaaa-aaaam-qarza-cai": "LuMari",
        "j7znt-tiaaa-aaaag-qazjq-cai": "Snowflakes",
        "jcpde-3aaaa-aaaag-qcyqq-cai": "COINS - Special",
        "jd5xc-eiaaa-aaaag-qazlq-cai": "LastWarrior",
        "jeghr-iaaaa-aaaah-qco7q-cai": "ICTurtles",
        "jgict-maaaa-aaaam-qa5xq-cai": "Margon ∞",
        "jh76l-5iaaa-aaaam-qawgq-cai": "The Digmonds",
        "jjeno-oyaaa-aaaak-aanua-cai": "ICWhiskers NFT (CrowdFundNFT)",
        "jk4ir-vaaaa-aaaag-qb4pa-cai": "Puzzles",
        "jkkkb-6aaaa-aaaam-qar2q-cai": "DFOOTY",
        "jmks5-jqaaa-aaaag-qbx6q-cai": "Dfinity Snake",
        "jmuqr-yqaaa-aaaaj-qaicq-cai": "ICP Squad",
        "jntyp-yiaaa-aaaah-qcr3q-cai": "ICPics",
        "jq4wk-diaaa-aaaag-qju3q-cai": "The Constructivists",
        "jqa6g-6aaaa-aaaah-qc2iq-cai": "Triad Boys Society",
        "jsmzz-qaaaa-aaaag-qa6vq-cai": "Gecko Mystery",
        "jtpfm-aiaaa-aaaag-qbpea-cai": "W.A.R.R.I.O.R.S",
        "jtzro-giaaa-aaaag-qbqbq-cai": "Boogle Academy",
        "juovk-aqaaa-aaaam-qa5uq-cai": "Cryptopengz",
        "juyx2-lqaaa-aaaag-qbqba-cai": "The Force Awakens",
        "jv55j-riaaa-aaaal-abvnq-cai": "Poked Bots Mutant Army",
        "jvax7-zyaaa-aaaak-aanwa-cai": "ICShellbacks",
        "jxpyk-6iaaa-aaaam-qafma-cai": "🌮 Taco NFTs",
        "jxz22-viaaa-aaaag-qbizq-cai": "BitBoy: Operation Bahamas Forever",
        "jzndq-iyaaa-aaaag-qbx5a-cai": "Dinos Pixel",
        "k2nwy-oaaaa-aaaag-qazca-cai": "The Satoshi Code",
        "k2pcx-jaaaa-aaaag-qb4ha-cai": "The Swop OG",
        "k4p2l-6qaaa-aaaam-qa2da-cai": "KawaiiVHS",
        "k4pmz-tqaaa-aaaag-qbita-cai": "Christmas-Ball",
        "k4qsa-4aaaa-aaaah-qbvnq-cai": "Elementum: Faceted Meninas",
        "k4zy3-vqaaa-aaaag-qbxwq-cai": "PR0GR4M D1SRUPT0R",
        "k5osr-jyaaa-aaaam-qaoxq-cai": "\"THE\" EGGs",
        "k7h5q-jyaaa-aaaan-qaaaq-cai": "Cosmicrafts",
        "k7obz-niaaa-aaaag-qbqlq-cai": "Starburst",
        "ka5ck-cqaaa-aaaag-qbxuq-cai": "BetBase Aliens",
        "kbk6s-tyaaa-aaaag-qb4fq-cai": "DeRF Tokens",
        "kd63f-3iaaa-aaaag-qakja-cai": "Blockchain Meme",
        "kdk3i-2iaaa-aaaag-qbqjq-cai": "City-verse",
        "kembn-6qaaa-aaaag-qc7ga-cai": "MotoGhosts",
        "kgjmj-zaaaa-aaaag-qazaa-cai": "LANDMARK",
        "kh4e6-piaaa-aaaag-qbxua-cai": "Infinity Symbols",
        "khln7-dqaaa-aaaap-qbiwq-cai": "Querio",
        "kijvo-fqaaa-aaaag-qb4ea-cai": "ISOMOTO",
        "kkjqu-maaaa-aaaag-qbqia-cai": "Burn The Clown",
        "kn3k4-jyaaa-aaaag-qdfha-cai": "cosmic_canvas",
        "kn6cc-hyaaa-aaaag-qbpna-cai": "\"WACKY DUDE-TUBES\"",
        "kojns-saaaa-aaaam-qa2aa-cai": "JEWELS",
        "kss7i-hqaaa-aaaah-qbvmq-cai": "ICelebrity",
        "kt2l3-uiaaa-aaaam-qarta-cai": "Vibrant Diamond",
        "l22ez-fqaaa-aaaah-qcwiq-cai": "DFINI∞SHIELDS",
        "l2cqd-oaaaa-aaaam-qawja-cai": "ICPlatypus",
        "l5vuh-iyaaa-aaaag-qb34a-cai": "FLAT ICP WORLD",
        "l7gnb-jiaaa-aaaag-qdc7q-cai": "NFT Pass",
        "lcgbg-kaaaa-aaaam-qaota-cai": "PHASMA",
        "legpi-qqaaa-aaaam-qa2ha-cai": "Baby Apes",
        "lgqic-saaaa-aaaag-qb36q-cai": "The Chain Warriors",
        "lhq4n-3yaaa-aaaai-qaniq-cai": "Principia Mathematica",
        "lisfk-jqaaa-aaaag-qb37q-cai": "GNight Punks",
        "lix2q-6yaaa-aaaal-qdbaa-cai": "IC KONG",
        "ljfzs-yyaaa-aaaag-qbqoq-cai": "Wen Lambo?",
        "ljt3c-tyaaa-aaaam-qa53a-cai": "IC Octoverse Phase-1",
        "ljwfo-qyaaa-aaaag-qdfba-cai": "Insane Clowntokos",
        "llf4i-riaaa-aaaag-qb4cq-cai": "Bear Pals",
        "llt6y-2iaaa-aaaam-qarxa-cai": "Exploring IC",
        "lmgot-3qaaa-aaaag-qazha-cai": "Energy Ghosts",
        "lnu2v-eyaaa-aaaag-qcy4a-cai": "PIXSOMNIA",
        "lqp4q-iqaaa-aaaak-aakga-cai": "Hatch Tickets",
        "lrd4y-3yaaa-aaaag-qanrq-cai": "ICP.NFT_Amirof First Chapter",
        "luw73-6qaaa-aaaag-qb35q-cai": "Provenance Skeletons",
        "lvbdd-pyaaa-aaaag-qbqmq-cai": "Dark of the Night",
        "lxmol-ciaaa-aaaak-abpdq-cai": "Internet Computer Footprint",
        "lyl7c-oaaaa-aaaan-qay6a-cai": "IC Flying Ghost",
        "lzhom-nqaaa-aaaap-ahmpq-cai": "B.A.D 3D Avatars",
        "m4fui-wyaaa-aaaag-qbejq-cai": "Holy Cats",
        "m5vub-oqaaa-aaaag-qcaxq-cai": "Legendary Warrior",
        "m6fha-siaaa-aaaam-qa2vq-cai": "Clouds of man",
        "m6frs-7iaaa-aaaag-qbifq-cai": "SANTA CLAUS",
        "m7ezi-iaaaa-aaaag-qb4ra-cai": "Martyrdom",
        "maboz-byaaa-aaaag-qbelq-cai": "MechaGon",
        "mcquu-6aaaa-aaaal-qciyq-cai": "Dove for Peace.",
        "mfa3f-iqaaa-aaaam-qa2xa-cai": "Myour",
        "mfhqa-iyaaa-aaaai-abona-cai": "ICLove",
        "mivz5-gyaaa-aaaag-qbp3a-cai": "Steampunk GameBoy",
        "mk3kn-pyaaa-aaaah-qcoda-cai": "DfinityDeck:Paradigm",
        "mmdgl-tyaaa-aaaag-qbigq-cai": "ZOOYORG",
        "mntgc-lqaaa-aaaag-qcmyq-cai": "ICP PUNKS",
        "mnu2t-cqaaa-aaaag-qbdxq-cai": "Who?",
        "mqriy-cyaaa-aaaag-qbxba-cai": "Vigorous",
        "mreap-uqaaa-aaaag-qazva-cai": "ICSocks",
        "mrgeq-xaaaa-aaaap-qhntq-cai": "SoZo Posts",
        "mrgua-tqaaa-aaaag-qb4qa-cai": "DfinityPunks Gen2",
        "mrqac-vqaaa-aaaag-qbdvq-cai": "CheckMate - FLAG",
        "mtuyy-6qaaa-aaaal-qjdoq-cai": "Mitoko Maker",
        "mytl6-dyaaa-aaaag-qbdua-cai": "DfinityPunks",
        "myuxp-kyaaa-aaaag-qcm3a-cai": "BAPES : Baby Apes",
        "mzb7y-4qaaa-aaaag-qdcpa-cai": "Davatars",
        "n37cy-xaaaa-aaaag-qbdsq-cai": "Pagans and Gods",
        "n57mw-nqaaa-aaaag-qbxgq-cai": "The Hidden Creature",
        "n5mqk-fqaaa-aaaag-qdcja-cai": "Brave & Beautiful",
        "n66bw-tiaaa-aaaag-qbp6a-cai": "Donald Duck Art",
        "n6bj5-ryaaa-aaaan-qaaqq-cai": "Initial Weapon of the Eimolad",
        "nb3wh-2qaaa-aaaag-qbxeq-cai": "RUG EXPOSED",
        "nbg4r-saaaa-aaaah-qap7a-cai": "Starverse",
        "nc2nv-jiaaa-aaaam-qa5ma-cai": "SKULLs",
        "ncmpf-ciaaa-aaaag-qbqzq-cai": "Internet Art Computers",
        "nd4pm-2aaaa-aaaag-qcuhq-cai": "ICP Rocks",
        "ndnrn-yaaaa-aaaam-qaw5a-cai": "CryptoSe7ens",
        "nembl-yyaaa-aaaag-qbenq-cai": "CheckMate DSCVR FLAG",
        "nf35t-jqaaa-aaaag-qbp4q-cai": "Pixamers: Dark Earth",
        "nfnjr-pqaaa-aaaag-qbqza-cai": "Dexterity Nebula",
        "nfvlz-jaaaa-aaaah-qcciq-cai": "ICGhost 3D Scenes",
        "nges7-giaaa-aaaaj-qaiya-cai": "Saga Legends: #0 The Fool",
        "niojz-kyaaa-aaaag-qbiaq-cai": "Alter Ego",
        "njgly-uaaaa-aaaah-qb6pa-cai": "ICPuppies",
        "njzvb-3qaaa-aaaag-qbdrq-cai": "Astrodelics",
        "nlzgj-7aaaa-aaaam-qa5nq-cai": "MUMMY",
        "nmilc-4iaaa-aaaal-qizkq-cai": "Vice Presidents",
        "nmywp-7yaaa-aaaag-qbp5a-cai": "Casual Watermelon",
        "nncvb-tyaaa-aaaah-abh2q-cai": "ICFlowers",
        "npz3p-baaaa-aaaag-qbxfq-cai": "Deluxe MDMA",
        "nu4hk-3yaaa-aaaag-qbxha-cai": "Vitalik Gold Trophy",
        "nwkaa-ziaaa-aaaam-qaw6q-cai": "Aplomb",
        "o3kmp-daaaa-aaaam-qa5fq-cai": "CYB",
        "o5l7c-tiaaa-aaaaf-qajwq-cai": "Nuance: Scytale",
        "o6lzt-kiaaa-aaaag-qbdza-cai": "PC Heads",
        "oapqk-zyaaa-aaaam-qa5ha-cai": "LuMari II: Throwback",
        "oazs2-syaaa-aaaag-qbqsq-cai": "ETH MEDAL",
        "obm2n-eqaaa-aaaag-qa6gq-cai": "Ghostokos",
        "oby2a-fqaaa-aaaag-qbega-cai": "The Richman ∞",
        "odyji-baaaa-aaaam-qa22a-cai": "Robot Scientists",
        "oeee4-qaaaa-aaaak-qaaeq-cai": "Motoko Day Drop",
        "ok3ug-2iaaa-aaaag-qbilq-cai": "IC8 Pixel",
        "ol244-naaaa-aaaag-qb47a-cai": "Bear Infinity",
        "olmi6-laaaa-aaaag-qbd2q-cai": "iMagiNary",
        "oqais-viaaa-aaaan-qatta-cai": "IC FRIENDSHIP",
        "os7fd-6iaaa-aaaag-qbqrq-cai": "Gojira",
        "ou7ln-eyaaa-aaaag-qbefq-cai": "IC-P Bot52",
        "ouj7p-cyaaa-aaaag-qb3aa-cai": "Grounded",
        "owuqd-dyaaa-aaaah-qapxq-cai": "ICPuzzle",
        "oy5vn-3yaaa-aaaam-qa2yq-cai": "IC FLOWERS",
        "oylx5-qyaaa-aaaag-qbxna-cai": "Crypto yeti",
        "p2oje-wiaaa-aaaak-qlhza-cai": "DMB Legendary",
        "p4q27-cyaaa-aaaam-qa26q-cai": "Caffesitas",
        "p5jg7-6aaaa-aaaah-qcolq-cai": "ICAliens",
        "p5rex-yqaaa-aaaag-qb42a-cai": "Doodles",
        "pacc6-6yaaa-aaaag-qbxja-cai": "IC Abstract",
        "par6c-wyaaa-aaaag-qdcgq-cai": "Meme Cats",
        "pauw4-yyaaa-aaaag-qbimq-cai": "The Clown",
        "pcatl-qiaaa-aaaag-qa6aa-cai": "BullPx",
        "pdgha-oaaaa-aaaag-qdf3q-cai": "SNEED Summers",
        "pdv34-gaaaa-aaaag-qbqua-cai": "Olympian Gods",
        "pk6rk-6aaaa-aaaae-qaazq-cai": "BTC Flower",
        "pkasq-3iaaa-aaaam-qa5aa-cai": "Triana Divine",
        "pkwqa-qiaaa-aaaag-qbqvq-cai": "ICP Raccon",
        "pmc6d-lyaaa-aaaag-qa6ba-cai": "Dragons",
        "pmrc7-dyaaa-aaaag-qcloq-cai": "Cyber Ninjas",
        "pnpu4-3aaaa-aaaah-qcceq-cai": "Infinite Chimps",
        "po6n2-uiaaa-aaaaj-qaiua-cai": "ICP Squad accessories",
        "pow3u-diaaa-aaaag-qbinq-cai": "A.C.A.P",
        "poyn6-dyaaa-aaaah-qcfzq-cai": "Blockchain Heroes",
        "psaup-3aaaa-aaaak-qsxlq-cai": "NFT Loteria",
        "pwskr-hiaaa-aaaag-qbqxq-cai": "When Pigs Fly",
        "px5ub-qqaaa-aaaah-qcjxa-cai": "Imagination Project",
        "pycz7-baaaa-aaaag-qjtrq-cai": "Zazas",
        "pzd64-5yaaa-aaaap-ahljq-cai": "Grapes of Wrath",
        "q3nxc-eyaaa-aaaah-aq2ha-cai": "Plebes",
        "q3zuo-baaaa-aaaag-qcr6a-cai": "COINS - Blockchain",
        "q56gr-sqaaa-aaaag-qbkfa-cai": "DSCVR's Best of 2022",
        "q5gez-uaaaa-aaaah-qcyuq-cai": "ICity ICmoe",
        "q5ist-uqaaa-aaaag-qbvaq-cai": "Foromons Genesis",
        "q6hjz-kyaaa-aaaah-qcama-cai": "Wrapped ICPBunny",
        "q6yae-4aaaa-aaaal-qcnha-cai": "Cyborgs",
        "qa4il-3yaaa-aaaag-qcr4q-cai": "OpenFPL Brand NFTs",
        "qbc6i-daaaa-aaaah-qcywq-cai": "Internet Humans",
        "qc3ra-3iaaa-aaaag-qbs7q-cai": "RetroGaming",
        "qcg3w-tyaaa-aaaah-qakea-cai": "ICPunks",
        "qfmve-5qaaa-aaaam-qa7kq-cai": "\"FLEUR\"",
        "qjwjm-eaaaa-aaaah-qctga-cai": "Dfinity Donkey",
        "qjyju-jqaaa-aaaam-qamca-cai": "Early Dog Trophies",
        "qklen-ryaaa-aaaal-abixa-cai": "Pixel Collection",
        "qkzeu-xiaaa-aaaam-qau2q-cai": "Squid Squad",
        "qqlej-4yaaa-aaaam-qa7ja-cai": "The Merge",
        "qrk2b-gqaaa-aaaag-qbznq-cai": "ANIME4",
        "qt4lz-jaaaa-aaaag-qbkea-cai": "Prince Owl",
        "qtk73-paaaa-aaaag-qbvbq-cai": "Switzerland",
        "qtywz-lqaaa-aaaal-qjgta-cai": "TRUMP MAGA HATS",
        "qxo6l-hyaaa-aaaag-qjr3a-cai": "FOOD COE",
        "qyjr5-qyaaa-aaaag-qbzma-cai": "Dom The Rapper",
        "r4e6p-jyaaa-aaaag-qbzka-cai": "The Czech Drop",
        "r5fwv-6qaaa-aaaag-qbn6q-cai": "DudeBox",
        "r5tcx-yqaaa-aaaag-qbs3a-cai": "Arcanist",
        "r6e3v-aiaaa-aaaag-qbvga-cai": "Bitcoin Vibranium",
        "r75rh-rqaaa-aaaah-qctda-cai": "Eleos",
        "rcabe-xiaaa-aaaag-qbvea-cai": "Outcast II",
        "rgm6h-oyaaa-aaaan-qcx5a-cai": "Top memecoin of 2023",
        "rhbck-taaaa-aaaag-qbziq-cai": "ICP Blockchain Birds",
        "rhg63-2aaaa-aaaag-qcwhq-cai": "icmigos",
        "ri5pt-5iaaa-aaaan-qactq-cai": "Dwarf Elders of Eimolad",
        "rityp-jqaaa-aaaal-qcnca-cai": "Baby Boxy",
        "riut2-zyaaa-aaaag-qbsyq-cai": "Mad Scientist",
        "rldky-baaaa-aaaag-qbvfq-cai": "Eshan & Jinora",
        "rln4s-bqaaa-aaaah-qcyrq-cai": "ICmoji Legends",
        "rmuo4-hyaaa-aaaam-qayqq-cai": "DFW",
        "rmuyo-kyaaa-aaaag-qbkaq-cai": "OFFSPRINGS",
        "rn2ta-rqaaa-aaaak-qiv5a-cai": "AMB Land Collection",
        "rnsmf-uqaaa-aaaag-qcr3a-cai": "OpenFPL Podcast NFTs",
        "rpdbm-saaaa-aaaag-qbn5q-cai": "A.I OWL",
        "rppv3-yqaaa-aaaan-qcx4q-cai": "ICPSwap 2022 Christmas NFT",
        "rpvvo-uaaaa-aaaag-qbsya-cai": "Trailblazing Mech",
        "rqgw5-3yaaa-aaaag-qbvha-cai": "Out of the Ether",
        "rqiax-3iaaa-aaaah-qcyta-cai": "DfinityDeck:Elements",
        "rqqc7-5yaaa-aaaag-qbkcq-cai": "TrollFace Meme",
        "rr6wy-jqaaa-aaaak-aaiqa-cai": "ICKitties Wearables",
        "rsehi-viaaa-aaaag-qa4oa-cai": "Cursed Skulls",
        "rug5j-iyaaa-aaaag-qbn7a-cai": "N4SC4R ∞",
        "rvhvt-7qaaa-aaaag-qbzlq-cai": "Helic of Earth",
        "rw623-hyaaa-aaaah-qctcq-cai": "OG MEDALS",
        "rw7qm-eiaaa-aaaak-aaiqq-cai": "ICKitties",
        "rxrsz-5aaaa-aaaam-qaysa-cai": "Orblings",
        "rxvzl-sqaaa-aaaal-qjgva-cai": "Motoko Punks",
        "rztjd-lqaaa-aaaag-qbkda-cai": "Spotted Owl",
        "s2fij-liaaa-aaaag-qa3zq-cai": "The Messenger",
        "s36wu-5qaaa-aaaah-qcyzq-cai": "Boxy Dude",
        "s4fgh-ryaaa-aaaag-qapnq-cai": "Jacob's art collection",
        "s4rgk-qyaaa-aaaag-qbvna-cai": "ICP BABES",
        "s4rro-jqaaa-aaaal-qbfyq-cai": "3D GHOST",
        "s6hwe-laaaa-aaaab-qaeba-cai": "DSCVR OG 21",
        "s7bu5-yiaaa-aaaal-qcnkq-cai": "CHIB",
        "s7q5y-daaaa-aaaam-qa7fq-cai": "Cybermob",
        "scxno-jiaaa-aaaag-qa4ga-cai": "CALI GODESSES",
        "sduhj-uaaaa-aaaam-qa7hq-cai": "Singularity Time",
        "sfclx-fqaaa-aaaag-qbgga-cai": "Black Crows",
        "shcy7-baaaa-aaaam-qay2a-cai": "The Mask",
        "sigxo-jyaaa-aaaag-qcrqq-cai": "ICP Renegades",
        "sjybn-raaaa-aaaah-qcy2q-cai": "Flat Fiat",
        "skjpp-haaaa-aaaae-qac7q-cai": "Pineapple Punks",
        "skx2h-piaaa-aaaag-qbnwa-cai": "Bone Punkzz",
        "sobtd-xiaaa-aaaam-qay3q-cai": "Humans: Dystopia",
        "soxrt-4iaaa-aaaag-qbvoa-cai": "ANIME",
        "sqwrc-vqaaa-aaaal-qdd7q-cai": "op_kitten",
        "sr4qi-vaaaa-aaaah-qcaaq-cai": "Internet Astronauts",
        "srggp-uqaaa-aaaag-qaxua-cai": "Hallow's End",
        "stv7j-vaaaa-aaaag-qcoxq-cai": "Innovation 5.0",
        "suks2-3yaaa-aaaak-qivuq-cai": "Motoko Mommies",
        "svsnw-gqaaa-aaaag-qbvmq-cai": "Nature Integration",
        "swtwe-viaaa-aaaam-qa7ea-cai": "neckless in museum",
        "sxe4o-jaaaa-aaaag-qbgfa-cai": "C.A.T",
        "syfnt-cyaaa-aaaag-qaxvq-cai": "Halloween-Gem",
        "syhes-kiaaa-aaaaj-azxda-cai": "Charles",
        "szsrl-tqaaa-aaaag-qa4eq-cai": "TWO PEOPLE",
        "t2eok-gyaaa-aaaah-qclwq-cai": "The Tranquility Collection",
        "t2mog-myaaa-aaaal-aas7q-cai": "Pet bots",
        "t3drq-7iaaa-aaaae-qac2a-cai": "FP DAO Flower",
        "t3lq2-raaaa-aaaag-qbswa-cai": "Monster Party",
        "t555s-uyaaa-aaaal-qbjsa-cai": "Genesis II",
        "t576z-kqaaa-aaaag-qa4cq-cai": "AICyber Skull",
        "t64re-6iaaa-aaaam-qatpa-cai": "Dionysus' Masks",
        "t7l3o-caaaa-aaaag-qbkoa-cai": "Whoops",
        "tbzqh-2qaaa-aaaag-qbzfq-cai": "Mountain Bitcoin",
        "tco7x-piaaa-aaaam-qamiq-cai": "3D motorcycles",
        "tde7l-3qaaa-aaaah-qansa-cai": "Cronic Wearables",
        "tdh62-qaaaa-aaaak-qloka-cai": "DJT BOSS",
        "tdpb7-vaaaa-aaaag-qbkma-cai": "IC Potential",
        "te62g-3iaaa-aaaal-qi43a-cai": "Galactic Aliens",
        "teytj-6yaaa-aaaag-qbvja-cai": "Mutant Death Turtles",
        "tfpyv-wyaaa-aaaal-qbonq-cai": "Baddest Ruffest",
        "tgwaz-xyaaa-aaaah-qcura-cai": "Frontliners",
        "tgywt-xiaaa-aaaag-qbzfa-cai": "Piggy Picks",
        "thn6e-baaaa-aaaag-qaxra-cai": "Dragon Inside Egg",
        "ti233-myaaa-aaaag-qbzea-cai": "DOG-G",
        "tj3tb-3qaaa-aaaag-qbnqq-cai": "Bony",
        "tjnhd-5qaaa-aaaag-qbsva-cai": "METRIC CATS",
        "tkmkd-diaaa-aaaag-qbknq-cai": "KING of PANDA",
        "tlpww-taaaa-aaaag-qa34a-cai": "CheckMate",
        "tnvo7-iaaaa-aaaah-qcy4q-cai": "ICKoalas",
        "trm6y-xqaaa-aaaag-qdafa-cai": "Steampunk Infinity",
        "trn4c-ciaaa-aaaag-qjwnq-cai": "Blockchain Pass",
        "tskpj-aiaaa-aaaag-qaxsq-cai": "8 Years Gang",
        "tvo7m-iyaaa-aaaai-qjjsa-cai": "IC Dinos Items",
        "twiqs-uiaaa-aaaag-qbkpq-cai": "Boo-Bear",
        "tx72y-iaaaa-aaaam-qatoq-cai": "Pyramidion: UFO",
        "txr2a-fqaaa-aaaah-qcmkq-cai": "Meme Cake",
        "tzjbp-7qaaa-aaaag-qa37a-cai": "IC Gora",
        "u23qv-paaaa-aaaag-qbndq-cai": "Dfty:Powerscuff Apes",
        "u2kyg-aaaaa-aaaag-qc5ja-cai": "BTC Flower Gen 2.0",
        "u4zku-sqaaa-aaaag-qa4sq-cai": "UNBORN DEVIL'S PAWN",
        "u52at-pyaaa-aaaam-qa7ta-cai": "Soulshards: Origin",
        "u5mcd-eyaaa-aaaag-qbsgq-cai": "Pizza Day Monsters",
        "u6npd-2aaaa-aaaag-qbk6a-cai": "BREATHE",
        "ub6mq-vyaaa-aaaag-qbnba-cai": "Retro Modern Pop Art",
        "uc7bq-laaaa-aaaag-qbvzq-cai": "ICTempies",
        "ufitg-ayaaa-aaaag-qbk4q-cai": "Chubby Sharky",
        "ufmrp-niaaa-aaaal-ab3eq-cai": "Motoko Batteries",
        "ufn3y-oyaaa-aaaag-qdawq-cai": "Land in Netherworld",
        "ugdkf-taaaa-aaaak-acoia-cai": "Motoko Mechs",
        "uh4wr-iiaaa-aaaag-qa4qa-cai": "Cavalry",
        "ui5hm-dqaaa-aaaag-qbnaq-cai": "Fast & Beast",
        "uilto-fqaaa-aaaag-qbsfa-cai": "CMN Gems",
        "uj63z-tyaaa-aaaag-qa4ra-cai": "SockHead",
        "uklwu-maaaa-aaaag-qb6ja-cai": "Chingums",
        "ukmkf-faaaa-aaaag-qcrga-cai": "$GHOST Halloween",
        "ulnv3-laaaa-aaaal-qcvha-cai": "Pixel Pals",
        "um5my-qqaaa-aaaag-qbvyq-cai": "ANIME3",
        "umly2-wqaaa-aaaag-qbk5a-cai": "Dfinity Fox",
        "ummtp-gyaaa-aaaal-qcvhq-cai": "Pixel Pals 2",
        "umqto-nyaaa-aaaah-abwoa-cai": "Cubetopia Pets",
        "unssi-hiaaa-aaaah-qcmya-cai": "ICPets",
        "uo5jc-zaaaa-aaaag-qbzuq-cai": "Collie Bollie",
        "uqpcl-bqaaa-aaaag-qbk7a-cai": "Babble Core Cards",
        "urjwa-7yaaa-aaaag-qcreq-cai": "Cyber Monkey",
        "usprd-faaaa-aaaam-qauda-cai": "IC Partymania",
        "utnz6-nqaaa-aaaag-qkbka-cai": "MYARTBAR - SWAP",
        "utopl-7iaaa-aaaag-qbshq-cai": "Visual of Vision",
        "uty3j-ziaaa-aaaag-qbnca-cai": "Modern & Minimalist",
        "utyn3-uiaaa-aaaam-qa7sa-cai": "IC Formation",
        "uu6bm-5qaaa-aaaag-qccnq-cai": "Boxxxed Animals",
        "uvxj2-ayaaa-aaaak-aapqa-cai": "Kreatives",
        "uvyvh-dyaaa-aaaag-qbzwa-cai": "ANIME5",
        "uzhxd-ziaaa-aaaah-qanaq-cai": "ICP News",
        "v2awd-oaaaa-aaaam-qayia-cai": "Tales of the Creeps",
        "v2ekv-yyaaa-aaaag-qjw2q-cai": "GG Guitar Collection",
        "v3b6z-ziaaa-aaaam-qam4q-cai": "IC Genesis",
        "v3x4j-siaaa-aaaag-qbbja-cai": "The-Agent",
        "v3zkd-syaaa-aaaah-qcm5a-cai": "ICKitties",
        "v4jsw-5aaaa-aaaan-qaoha-cai": "The NFT jointly by ICPSwap & DfiStarter",
        "v5bgf-oyaaa-aaaag-qbkyq-cai": "BTC Integration",
        "v5dsk-jyaaa-aaaag-qap5q-cai": "ICP.NFT_Amirof second chapter",
        "v6gck-vqaaa-aaaal-qi3sa-cai": "GG Album Release",
        "v6wjv-3aaaa-aaaam-qa7vq-cai": "TRIPDRIP",
        "v7vsu-wqaaa-aaaai-qhpsa-cai": "Hatch Lottery Tickets",
        "veq7x-4qaaa-aaaag-qa4wq-cai": "Astro Pixel",
        "vesly-3qaaa-aaaag-qbztq-cai": "PVRTY",
        "vfclr-dyaaa-aaaag-qc5nq-cai": "Spooky Pixel DAO",
        "vffxa-kyaaa-aaaag-qbscq-cai": "Cthulhu🐙",
        "vftdc-myaaa-aaaag-qbnha-cai": "Rebellion Of 1977",
        "vigb2-cqaaa-aaaam-qayla-cai": "Puzzle",
        "vj752-6iaaa-aaaah-qcm6a-cai": "The Equanimity Collection",
        "vkqgq-aaaaa-aaaag-qbzsq-cai": "New Era Tamagotchi",
        "vlh2i-riaaa-aaaag-qbsdq-cai": "Landschap /natural/",
        "vlhm2-4iaaa-aaaam-qaatq-cai": "CAP Crowns",
        "vsaxy-faaaa-aaaag-qa3ia-cai": "SAINT",
        "vvdfd-pyaaa-aaaag-qb6nq-cai": "Dfinity Mask",
        "vvvht-eyaaa-aaaam-qatya-cai": "World of Tacos",
        "vwc6r-4aaaa-aaaam-qaufa-cai": "AOKI",
        "w4vw2-aqaaa-aaaag-qbsla-cai": "Rebellion Of 1988",
        "wdokm-kiaaa-aaaak-qlrsa-cai": "Steve NFT Test",
        "weht5-cqaaa-aaaag-qbvuq-cai": "ANIME2",
        "wettq-dqaaa-aaaag-qapua-cai": "The Circle of Life",
        "wghwh-laaaa-aaaag-qbzyq-cai": "Glassy Dynamics",
        "whcd5-6yaaa-aaaal-qjb3a-cai": "Spectra",
        "whdwd-siaaa-aaaag-qdhga-cai": "CYBERNETICS",
        "wjazr-4aaaa-aaaag-qjrpq-cai": "Miballs",
        "wkf6v-zaaaa-aaaag-qbvvq-cai": "ICSnpy",
        "wlea5-diaaa-aaaam-qatra-cai": "Motoko Piñatas",
        "wpe53-5iaaa-aaaag-qbzza-cai": "NURSE S1",
        "wpgju-2iaaa-aaaag-qa44a-cai": "Fleshly NFT",
        "wrrkd-myaaa-aaaag-qcf5q-cai": "3D punks on IC",
        "wvujj-ryaaa-aaaag-qaxpq-cai": "Infinity Symbol",
        "wwxqg-iaaaa-aaaag-qbksa-cai": "CHIMERA👾",
        "wxi2q-oiaaa-aaaaj-qab2q-cai": "Cake",
        "wxrtj-paaaa-aaaal-qcb4a-cai": "IC Opepen Edition",
        "wyv5o-tqaaa-aaaag-qbkta-cai": "IC Bears",
        "wz42r-viaaa-aaaak-apacq-cai": "lili PUMP",
        "x2oiq-waaaa-aaaag-qbbeq-cai": "Legend of Atlantis",
        "x4oqm-bqaaa-aaaam-qahaq-cai": "DRIP BANG",
        "x6avo-fqaaa-aaaah-qcuiq-cai": "Content Fly Deliverable Ownership",
        "x6mxl-caaaa-aaaag-qa4zq-cai": "Say CORAL! 📸",
        "x7pl6-siaaa-aaaag-qbnia-cai": "VS MILLIONAIRES",
        "x7z74-uiaaa-aaaag-qbsnq-cai": "IS NOT ART",
        "xak4p-3qaaa-aaaag-qbvsq-cai": "Pixel Mom",
        "xcep7-sqaaa-aaaah-qcukq-cai": "3D Assassins!!!",
        "xdlh5-iiaaa-aaaam-qa72a-cai": "Portal Hunt",
        "xdzpj-yqaaa-aaaag-qjona-cai": "Ringleaders",
        "xe37i-hqaaa-aaaag-qc5aa-cai": "Attic_EW",
        "xe45w-fyaaa-aaaai-qkgfa-cai": "IC Dinos Gen2",
        "xe4dz-oqaaa-aaaag-qbspa-cai": "EMOTE Badge",
        "xeyge-6yaaa-aaaap-ahcba-cai": "Jester Medallions",
        "xfjlo-yyaaa-aaaag-qa43a-cai": "Cacti with an I",
        "xgket-maaaa-aaaam-qatwq-cai": "Calavera Collection",
        "xh5oz-qiaaa-aaaag-qbkxq-cai": "BlockC",
        "xkbqi-2qaaa-aaaah-qbpqq-cai": "ICPBunny",
        "xoirh-aaaaa-aaaag-qbvtq-cai": "The Privateer",
        "xphpx-xyaaa-aaaah-qcmta-cai": "CYMAN",
        "xpjz5-xiaaa-aaaag-qbbha-cai": "WOLVES",
        "xumfy-nqaaa-aaaag-qbbfq-cai": "Santa iistronauts",
        "xv3za-4yaaa-aaaag-qbkuq-cai": "Dolphin Shear",
        "xwmac-eaaaa-aaaag-qbnjq-cai": "Dexterity Galaxy",
        "xxp4x-uiaaa-aaaag-qa4ya-cai": "TWINs",
        "xyjr3-wqaaa-aaaag-qcchq-cai": "Zombie Apocalypse",
        "xylfu-rqaaa-aaaag-qdhcq-cai": "ICP.Hub Balkan",
        "xyonk-7qaaa-aaaag-qbniq-cai": "ULTRA CAPOTIFO",
        "xyyzi-zqaaa-aaaag-qbsna-cai": "Landschap /abstract/",
        "xz4z4-qyaaa-aaaap-abhta-cai": "Digital Art Showcase",
        "xzcnc-myaaa-aaaak-abk7a-cai": "IC Ghosts NFT Collection",
        "xzxhy-oiaaa-aaaah-qclnq-cai": "YOLO Octopus",
        "y2ga5-lyaaa-aaaae-qae2q-cai": "Cherries",
        "y3b7h-siaaa-aaaah-qcnwa-cai": "Wrapped ICats",
        "y3st3-oyaaa-aaaah-aec2q-cai": "Phyxls",
        "y47hk-qaaaa-aaaag-qcqia-cai": "BABY AROF Lottery ( 1 )",
        "y5ntm-piaaa-aaaag-qarta-cai": "Galactic Saloon: Space Cowboys",
        "y5phd-iiaaa-aaaag-qbuwa-cai": "Fascinating Species",
        "y5prr-fiaaa-aaaam-qagga-cai": "DogFinity",
        "y6okd-wqaaa-aaaag-qbmoq-cai": "Chimera: 8-Bit👾",
        "ya4bk-oaaaa-aaaag-qb7fa-cai": "ICY Pepe",
        "ya6vf-jaaaa-aaaag-qa2aa-cai": "IC Ghostery",
        "ybl5s-7iaaa-aaaag-qbuua-cai": "Bitcoin Frost",
        "yc4eq-hqaaa-aaaag-qbtja-cai": "Fish Tronic",
        "yckqs-bqaaa-aaaag-qbmmq-cai": "Little Monster",
        "yd2q3-zyaaa-aaaag-qcisq-cai": "50 SLICES NFTs",
        "yd5mk-qyaaa-aaaag-qbh5q-cai": "eCops",
        "yek64-3aaaa-aaaag-qbyyq-cai": "Rabbit Punk",
        "yflau-biaaa-aaaam-qa64a-cai": "ICPDIAMONDS",
        "yflwg-miaaa-aaaag-qbmma-cai": "eWeird",
        "yfmkx-fiaaa-aaaag-qcdda-cai": "Chat GPT CUBE",
        "yhsek-pyaaa-aaaak-qiumq-cai": "Telebunnies '98",
        "yigae-jqaaa-aaaah-qczbq-cai": "Earn Contracts",
        "yjr44-yyaaa-aaaah-qcsqq-cai": "Content Fly PoJC",
        "yk22w-eaaaa-aaaal-qjlla-cai": "Motokos at Nashville",
        "yk3mj-miaaa-aaaah-aq4pq-cai": "ICPP Art",
        "yl7pm-ryaaa-aaaag-qbtiq-cai": "3D Macintosh",
        "ylyt5-yyaaa-aaaag-qc4hq-cai": "Atomicsheep",
        "ym2d4-hyaaa-aaaag-qjpkq-cai": "World Epoch",
        "yrdz3-2yaaa-aaaah-qcvpa-cai": "IC Dinos",
        "ysmud-jqaaa-aaaam-qastq-cai": "ICFantasyWorld",
        "yv3qh-piaaa-aaaag-qb7gq-cai": "Mystical Bitcoin",
        "yx3v5-gyaaa-aaaag-qbtkq-cai": "Neuron Shapes",
        "yy7m6-daaaa-aaaag-qciqa-cai": "Enchanted Bonsai",
        "yyyqp-kaaaa-aaaag-qbh7a-cai": "IC ELEMENTS",
        "yzpmx-3iaaa-aaaag-qbmoa-cai": "Figures",
        "yzzyv-5iaaa-aaaag-qbtlq-cai": "Skull Coin-verse",
        "z4v75-taaaa-aaaag-qbhza-cai": "Legendary Gods",
        "z5uxh-eiaaa-aaaag-qbtnq-cai": "Aquatic Human",
        "z6vmv-xqaaa-aaaam-qazfa-cai": "My Monsters",
        "z7mqv-liaaa-aaaah-qcnqa-cai": "ICircle - Pythagoras",
        "zarfm-eaaaa-aaaag-qbh3a-cai": "Emperor of Mars",
        "zdvxw-nqaaa-aaaal-qdf4a-cai": "Goated Gamer",
        "zejmq-rqaaa-aaaah-qcnsq-cai": "Elementum: Interitus",
        "zgadr-rqaaa-aaaag-qcdfq-cai": "CrazyMiccckey",
        "zghjs-vqaaa-aaaam-qa62q-cai": "Block Busters",
        "zgt7n-zqaaa-aaaag-qawka-cai": "BABY AROF army",
        "zhibq-piaaa-aaaah-qcvka-cai": "Panda Queen",
        "ziu23-maaaa-aaaag-qc4ba-cai": "GALAX!",
        "zjsoq-siaaa-aaaag-qbh2q-cai": "X-MAS TREE",
        "zkw4k-3yaaa-aaaal-qdf5q-cai": "PEELADIES",
        "zle7i-5yaaa-aaaag-qbuta-cai": "angeloid💕",
        "zlkjc-5iaaa-aaaah-qczha-cai": "Wojak NFT",
        "zmlpw-qqaaa-aaaah-qczhq-cai": "Genshin Dolls",
        "zndnx-oiaaa-aaaag-qcpia-cai": "Enigma",
        "znx26-waaaa-aaaal-qdf5a-cai": "D_O_G",
        "zot6w-sqaaa-aaaam-qavka-cai": "ICLands Train",
        "zoxve-5aaaa-aaaal-qjlna-cai": "Vires In Numeris",
        "zpaj4-miaaa-aaaal-qja4a-cai": "Journey to Chain Fusion",
        "zpb4c-ayaaa-aaaag-qdgba-cai": "Windoge 11",
        "zqpvh-hqaaa-aaaah-qczfq-cai": "ICKitsune",
        "zubiz-uaaaa-aaaag-qbmjq-cai": "Boomers",
        "zvycl-fyaaa-aaaah-qckmq-cai": "ICApes",
        "zydwz-laaaa-aaaam-qasuq-cai": "Celestials",
        "zyvuj-aaaaa-aaaag-qb7ba-cai": "The Road Project",
        "zzk67-giaaa-aaaaj-qaujq-cai": "The High Priestess"
    }
};
export default ICP_COLLECTION_CATALOG;
